import AddIcon from "@mui/icons-material/Add";
import AlarmIcon from "@mui/icons-material/Alarm";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import { Box, Card, Grid, Tooltip, Typography } from "@mui/material";
import { groupBy } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import FieldInfoIcon, {
  FieldHelpLabel,
} from "../../../components/FieldInfoIcon";
import {
  default as CustomSelect,
  default as Select,
} from "../../../components/Select/Select";
import {
  createClinicForm,
  createClinicService,
  createDiagnosticTemplate,
  createServiceRemainder,
  editClinicService,
  getClinicCertificatesWoLoader,
  getClinicFormsWoLoader,
  getDiagnosticTemplateByIdWoLoader,
  getDiagnosticTemplatesWoLoader,
  getServiceRemainders,
  getServicesWoLoader,
  updateClinicCertificateById,
  updateDiagnosticTemplateById,
  updateFromById,
  updateServiceRemainderById,
} from "../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { showSnackBar } from "../../../redux/reducers/snackSlice";
import { isActiveRecord } from "../../../util/activeStatus";
import { AppColors } from "../../../util/AppColors";
import { frequncyCheckList } from "../../../util/arrayList";
import { addIcon, delBtn, plusBtn } from "../../../util/CommonIconStyle";
import {
  doneAtList,
  mealTypes,
  modalities,
  regionList,
  routeList,
  sampleTypes,
  ServiceTypes,
  serviceTypes,
  yesNoValueList,
} from "../../../util/dropList";
import { frequencyConEnum, frequencyEnum } from "../../../util/enum";
import {
  getRightPackageUom,
  getTotalEstimatedCost,
  matchStrIgnoreCase,
} from "../../../util/function";
import { patchMandateSession } from "../../../util/mandateSessionStorage";
import { SERVICE_FIELD_HELP } from "../../../util/serviceFieldHelp";
import { DEFAULT_FOOTER_NOTE } from "../../Hospital/Plan/certificateConstants";
import DiagnosticTemplateCreate from "../../Hospital/Plan/DiagnosticTemplateCreate";
import ReminderTemplateModal from "../../Hospital/Plan/ReminderTemplateModal";

const hl = (label, key) => (
  <FieldHelpLabel label={label} infoText={SERVICE_FIELD_HELP[key]} />
);

const ColHelp = ({ children, helpKey }) => (
  <div className="flex-row-ali-cen">
    <Typography className="txt-semi-bold fs12 blue-color">
      {children}
    </Typography>
    <FieldInfoIcon text={SERVICE_FIELD_HELP[helpKey]} />
  </div>
);

const cardSty = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
};
const initVariants = { consumList: [], presList: [], prescriptions: [] };
const initVariant = { modOpen: false, consumList: [], presList: [] };
const initItem = {
  name: "",
  quantity: "1",
  cost: 0,
  route: null,
  dosage: "",
  delete: false,
  batchNumber: null,
  uom: null,
};
const requiredFieldList = [
  "category",
  "subCategory",
  "serviceName",
  "taxApplicability",
  "tax",
  "modality",
  // "diagnosticTemplate",
];
const initialValues = {
  type: "Medical",
  category: null,
  subCategory: null,
  serviceName: "",
  taxApplicability: "No",
  name: "",
  tax: "",
  serviceCharge: "",
  servicePrice: "",
  description: "",
  hsnSacCode: "",
  variants: [{ ...initVariant, i: 0 }],
  sampleType: "Blood",
  doneAt: "In-house",
  modality: null,
  device: "MRI",
  processingTime: "",
  region: [],
  diagnosticTemplate: null,
  nextDueType: "day",
  nextDueValue: "",
  linkedSubcategories: [],
};
const initialError = {
  category: false,
  subCategory: false,
  serviceName: false,
  taxApplicability: false,
  serviceCharge: false,
  servicePrice: false,
  description: false,
  hsnSacCode: false,
  diagnosticTemplate: false,
};
const initialHelp = {
  category: "",
  subCategory: "",
  serviceName: "",
  taxApplicability: "",
  serviceCharge: "",
  servicePrice: "",
  description: "",
  hsnSacCode: "",
  diagnosticTemplate: "",
};
const defObj = {
  services: [],
  stocks: [],
  facilities: [],
  locations: [],
  dataSharing: {},
  clinic: {},
  serviceCategories: [],
  stockCategories: [],
  serviceRemainders: [],
  diagnosticTemplates: [],
  forms: [],
  certificates: [],
};

const getRemainderId = (tmp) =>
  tmp?.serviceRemainderId ?? tmp?.templateId ?? tmp?.id ?? null;

const getDiagnosticTemplateId = (tmp) =>
  tmp?.templateId ?? tmp?.diagnosticTemplateId ?? tmp?.id ?? null;

const getFormId = (frm) => frm?.formId ?? frm?.id ?? null;

const getCertificateId = (cert) => cert?.certificateId ?? cert?.id ?? null;

const getTemplateLinkedIds = (tmp) =>
  (tmp?.linkedServices ?? tmp?.serviceIds ?? [])
    ?.map((ser) =>
      typeof ser === "object" && ser !== null
        ? (ser?.serviceId ?? ser?.value)
        : ser,
    )
    ?.filter((id) => id != null && id !== "");

const templateLinksService = (tmp, serviceId) => {
  if (serviceId == null || serviceId === "") return false;
  return getTemplateLinkedIds(tmp)?.some(
    (id) => String(id) === String(serviceId),
  );
};

const getTemplateStepSummary = (tmp) => {
  const steps = tmp?.steps ?? tmp?.serviceRemainderSteps ?? [];
  const names = (steps ?? [])
    ?.map((st) => st?.stepName ?? st?.name)
    ?.filter(Boolean);
  const count = names?.length || steps?.length || 0;
  const trail = names?.length > 0 ? names.join(" -> ") : "";
  return count > 0
    ? `${count} step${count === 1 ? "" : "s"}${trail ? ` · ${trail}` : ""}`
    : "No steps";
};

const getDiagnosticTemplateSummary = (tmp) => {
  const type = tmp?.type ?? "";
  const questionCount = Array.isArray(tmp?.question) ? tmp.question.length : 0;
  if (type === "report") return "Report template";
  if (questionCount > 0) {
    return `${questionCount} parameter${questionCount === 1 ? "" : "s"}`;
  }
  return type ? String(type) : "No parameters";
};

const getFormSummary = (frm) => {
  const type = frm?.serviceType ?? "";
  const linkedCount = getTemplateLinkedIds(frm)?.length ?? 0;
  if (type && linkedCount > 0) {
    return `${type} · ${linkedCount} service${linkedCount === 1 ? "" : "s"}`;
  }
  return type || "Consent form";
};

const getCertificateSummary = (cert) => {
  const note = cert?.note ?? cert?.footerNote ?? "";
  if (!note) return "Certificate";
  return note.length > 72 ? `${note.slice(0, 72)}...` : note;
};

const mergeLinkedServiceIds = (tmp, extraServiceIds = []) => [
  ...new Set(
    [...getTemplateLinkedIds(tmp), ...extraServiceIds]
      ?.filter((id) => id != null && id !== "")
      ?.map((id) => (Number(id) ? Number(id) : id)),
  ),
];

const toSubCategoryList = (subCategories) => {
  const list = Array.isArray(subCategories) ? subCategories : [];
  return list
    .filter((sc) => sc?.name && isActiveRecord(sc))
    .map((sc) => ({
      name: sc.name,
      value: sc.name,
      id: sc.id,
    }));
};

const getAllLinkedStockSubCategoryOptions = (categories = []) => {
  const options = [];
  (categories ?? []).forEach((cat) => {
    toSubCategoryList(cat?.subCategories)?.forEach((sc) => {
      if (!options.some((opt) => opt.value === sc.value)) {
        options.push({ ...sc, categoryName: cat?.name ?? "" });
      }
    });
  });
  return options.sort((a, b) => a.name.localeCompare(b.name));
};

const parseLinkedSubCategories = (raw, options = []) => {
  const values = Array.isArray(raw) ? raw : [];
  return values
    .map((item) => {
      const name =
        typeof item === "string"
          ? item
          : (item?.name ?? item?.value ?? item?.subCategory ?? "");
      if (!name) return null;
      return (
        options.find((opt) => opt.value === name || opt.name === name) ?? {
          name,
          value: name,
        }
      );
    })
    .filter(Boolean);
};

const ServiceCreateUpdate = ({
  modVsble,
  selectedService,
  onCloseMod = () => {},
}) => {
  const dispatch = useDispatch();
  const [serviceValues, setServiceValues] = useState(initialValues);
  const [serviceErrors, setServiceErrors] = useState(initialError);
  const [serviceHelps, setServiceHelps] = useState(initialHelp);
  const [slctedVariant, setSlctedVariant] = useState(null);
  const [variantValues, setVariantValues] = useState(initVariants);
  const [alternates, setAlternates] = useState([]);
  const [consumOpen, setConsumOpen] = useState(true);
  const [adminOpen, setAdminOpen] = useState(true);
  const [itemErrors, setItemErrors] = useState({
    consumList: [],
    presList: [],
  });
  const [remainderModalOpen, setRemainderModalOpen] = useState(false);
  const [selectedRemainder, setSelectedRemainder] = useState(null);
  const [addRemainderOpen, setAddRemainderOpen] = useState(false);
  const [pickedRemainder, setPickedRemainder] = useState("");
  const [remainderSaving, setRemainderSaving] = useState(false);
  const [addDiagTempOpen, setAddDiagTempOpen] = useState(false);
  const [pickedDiagTemp, setPickedDiagTemp] = useState("");
  const [selectedDiagTemp, setSelectedDiagTemp] = useState(null);
  const [diagTempCreateVsble, setDiagTempCreateVsble] = useState(false);
  const [diagTempSaving, setDiagTempSaving] = useState(false);
  const [addFormOpen, setAddFormOpen] = useState(false);
  const [pickedForm, setPickedForm] = useState("");
  const [formEditorOpen, setFormEditorOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [formEditorValues, setFormEditorValues] = useState({
    name: "",
    serviceType: "",
    content: "",
  });
  const [formSaving, setFormSaving] = useState(false);
  const [addCertOpen, setAddCertOpen] = useState(false);
  const [pickedCert, setPickedCert] = useState("");
  const [certEditorOpen, setCertEditorOpen] = useState(false);
  const [selectedCert, setSelectedCert] = useState(null);
  const [certEditorValues, setCertEditorValues] = useState({
    name: "",
    note: DEFAULT_FOOTER_NOTE,
  });
  const [certSaving, setCertSaving] = useState(false);
  const {
    servicesList,
    branchesDataSharing,
    diagnosticTemplates,
    serviceRemainders,
    forms: clinicForms,
    certificates: clinicCertificates,
  } = useSelector((state) => state?.clinic);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    services,
    stocks,
    facilities,
    locations,
    dataSharing,
    clinic,
    serviceCategories,
    stockCategories,
    serviceRemainders: mandateRemainders,
    diagnosticTemplates: mandateDiagnosticTemplates,
    forms: mandateForms,
    certificates: mandateCertificates,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      const categories = Array.isArray(reqData?.categories)
        ? reqData.categories
        : [];
      return {
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        locations: Array.isArray(reqData?.locations) ? reqData?.locations : [],
        dataSharing: reqData?.dataSharing ?? {},
        clinic: reqData?.clinic ?? {},
        serviceCategories: categories
          ?.filter(
            (cat) =>
              cat?.type === "services" && cat?.name && isActiveRecord(cat),
          )
          ?.map((cat) => ({
            name: cat.name,
            value: cat.name,
            id: cat.id,
            categoryType: cat.categoryType ?? null,
            subCategories: Array.isArray(cat.subCategories)
              ? cat.subCategories
              : [],
          })),
        stockCategories: categories
          ?.filter(
            (cat) => cat?.type === "stock" && cat?.name && isActiveRecord(cat),
          )
          ?.map((cat) => ({
            name: cat.name,
            value: cat.name,
            id: cat.id,
            subCategories: Array.isArray(cat.subCategories)
              ? cat.subCategories
              : [],
          })),
        serviceRemainders: Array.isArray(reqData?.serviceRemainders)
          ? reqData.serviceRemainders
          : [],
        diagnosticTemplates: Array.isArray(reqData?.diagnosticTemplates)
          ? reqData.diagnosticTemplates
          : [],
        forms: Array.isArray(reqData?.forms) ? reqData.forms : [],
        certificates: Array.isArray(reqData?.certificates)
          ? reqData.certificates
          : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);

  const subCategoryList = useMemo(
    () => toSubCategoryList(serviceValues?.category?.subCategories),
    [serviceValues?.category?.subCategories],
  );

  const allLinkedSubCategoryOptions = useMemo(
    () => getAllLinkedStockSubCategoryOptions(stockCategories),
    [stockCategories],
  );

  const allRemainders = useMemo(() => {
    if (Array.isArray(serviceRemainders) && serviceRemainders.length > 0) {
      return serviceRemainders;
    }
    return Array.isArray(mandateRemainders) ? mandateRemainders : [];
  }, [serviceRemainders, mandateRemainders]);

  const currentServiceId = selectedService?.serviceId ?? null;

  const linkedRemainderTemplates = useMemo(
    () =>
      (allRemainders ?? [])?.filter((tmp) =>
        templateLinksService(tmp, currentServiceId),
      ),
    [allRemainders, currentServiceId],
  );

  const unlinkedRemainderOptions = useMemo(
    () =>
      (allRemainders ?? [])
        ?.filter((tmp) => !templateLinksService(tmp, currentServiceId))
        ?.map((tmp) => ({
          name: tmp?.templateName ?? tmp?.name ?? "Untitled",
          value: getRemainderId(tmp),
        }))
        ?.filter((opt) => opt?.value != null && opt?.value !== ""),
    [allRemainders, currentServiceId],
  );

  const allDiagnosticTemplates = useMemo(() => {
    const fromRedux =
      diagnosticTemplates?.list ?? diagnosticTemplates?.data ?? [];
    if (Array.isArray(fromRedux) && fromRedux.length > 0) {
      return fromRedux;
    }
    return Array.isArray(mandateDiagnosticTemplates)
      ? mandateDiagnosticTemplates
      : [];
  }, [diagnosticTemplates, mandateDiagnosticTemplates]);

  const linkedDiagnosticTemplates = useMemo(
    () =>
      (allDiagnosticTemplates ?? [])?.filter((tmp) =>
        templateLinksService(tmp, currentServiceId),
      ),
    [allDiagnosticTemplates, currentServiceId],
  );

  const unlinkedDiagnosticOptions = useMemo(
    () =>
      (allDiagnosticTemplates ?? [])
        ?.filter((tmp) => !templateLinksService(tmp, currentServiceId))
        ?.map((tmp) => ({
          name: tmp?.templateName ?? tmp?.name ?? "Untitled",
          value: getDiagnosticTemplateId(tmp),
        }))
        ?.filter((opt) => opt?.value != null && opt?.value !== ""),
    [allDiagnosticTemplates, currentServiceId],
  );

  const allForms = useMemo(() => {
    if (Array.isArray(clinicForms) && clinicForms.length > 0) {
      return clinicForms;
    }
    return Array.isArray(mandateForms) ? mandateForms : [];
  }, [clinicForms, mandateForms]);

  const linkedConsentForms = useMemo(
    () =>
      (allForms ?? [])?.filter((frm) =>
        templateLinksService(frm, currentServiceId),
      ),
    [allForms, currentServiceId],
  );

  const unlinkedFormOptions = useMemo(
    () =>
      (allForms ?? [])
        ?.filter((frm) => !templateLinksService(frm, currentServiceId))
        ?.map((frm) => ({
          name: frm?.name ?? "Untitled",
          value: getFormId(frm),
        }))
        ?.filter((opt) => opt?.value != null && opt?.value !== ""),
    [allForms, currentServiceId],
  );

  const allCertificates = useMemo(() => {
    if (Array.isArray(clinicCertificates) && clinicCertificates.length > 0) {
      return clinicCertificates;
    }
    return Array.isArray(mandateCertificates) ? mandateCertificates : [];
  }, [clinicCertificates, mandateCertificates]);

  const linkedCertificates = useMemo(
    () =>
      (allCertificates ?? [])?.filter((cert) =>
        templateLinksService(cert, currentServiceId),
      ),
    [allCertificates, currentServiceId],
  );

  const unlinkedCertificateOptions = useMemo(
    () =>
      (allCertificates ?? [])
        ?.filter((cert) => !templateLinksService(cert, currentServiceId))
        ?.map((cert) => ({
          name: cert?.name ?? "Untitled",
          value: getCertificateId(cert),
        }))
        ?.filter((opt) => opt?.value != null && opt?.value !== ""),
    [allCertificates, currentServiceId],
  );

  const refreshRemainders = () => {
    dispatch(getServiceRemainders()).then((res) => {
      const payload = res?.payload;
      if (payload == null) return;
      patchMandateSession({
        serviceRemainders: Array.isArray(payload) ? payload : [],
      });
    });
  };

  const refreshDiagnosticTemplates = () => {
    dispatch(getDiagnosticTemplatesWoLoader("?page=1&itemSize=1000")).then(
      (res) => {
        if (res?.payload == null) return;
        const list = res?.payload?.list ?? res?.payload?.data ?? [];
        patchMandateSession({
          diagnosticTemplates: Array.isArray(list) ? list : [],
        });
      },
    );
  };

  const refreshForms = () => {
    dispatch(getClinicFormsWoLoader()).then((res) => {
      const payload = res?.payload;
      if (payload == null) return;
      patchMandateSession({
        forms: Array.isArray(payload) ? payload : [],
      });
    });
  };

  const refreshCertificates = () => {
    dispatch(getClinicCertificatesWoLoader()).then((res) => {
      const payload = res?.payload;
      if (payload == null) return;
      patchMandateSession({
        certificates: Array.isArray(payload) ? payload : [],
      });
    });
  };

  const buildRemainderPayload = (tmp, extraServiceIds = []) => {
    const existingIds = getTemplateLinkedIds(tmp);
    const linkedServices = [
      ...new Set(
        [...existingIds, ...extraServiceIds]
          ?.filter((id) => id != null && id !== "")
          ?.map((id) => (Number(id) ? Number(id) : id)),
      ),
    ];
    const steps = (tmp?.steps ?? tmp?.serviceRemainderSteps ?? [])?.map(
      (st, index) => {
        const isAnchor = Boolean(st?.isAnchor) || index === 0;
        return {
          stepId: st?.stepId ?? null,
          stepOrder: index + 1,
          stepName: st?.stepName ?? st?.name ?? `Dose ${index + 1}`,
          dueAfterDays: isAnchor ? 0 : Number(st?.dueAfterDays) || 0,
          remindBeforeDays: isAnchor ? 0 : Number(st?.remindBeforeDays) || 0,
          remindEveryDays: isAnchor ? 0 : Number(st?.remindEveryDays) || 0,
          expireAfter: isAnchor ? 0 : Number(st?.expireAfter) || 0,
          expireUnit: st?.expireUnit || "days",
        };
      },
    );
    return {
      templateName: tmp?.templateName ?? tmp?.name ?? "",
      occurrenceLabel: tmp?.occurrenceLabel || "Dose",
      linkedServices,
      steps,
    };
  };

  const handleOpenAddRemainder = () => {
    if (currentServiceId && unlinkedRemainderOptions?.length > 0) {
      setPickedRemainder("");
      setAddRemainderOpen(true);
      return;
    }
    handleCreateRemainder();
  };

  const handleCreateRemainder = () => {
    setAddRemainderOpen(false);
    setPickedRemainder("");
    setSelectedRemainder(
      currentServiceId
        ? {
            linkedServices: [currentServiceId],
            occurrenceLabel: "Dose",
            steps: [],
          }
        : null,
    );
    setRemainderModalOpen(true);
  };

  const handleEditRemainder = (tmp) => {
    setSelectedRemainder(tmp);
    setRemainderModalOpen(true);
  };

  const handleCloseRemainderModal = () => {
    setRemainderModalOpen(false);
    setSelectedRemainder(null);
  };

  const handleSaveRemainder = (data) => {
    if (remainderSaving) return;
    const serviceRemainderId = getRemainderId(selectedRemainder);
    const payload = { ...data };
    if (currentServiceId) {
      const linked = (payload?.linkedServices ?? [])?.map((id) =>
        Number(id) ? Number(id) : id,
      );
      if (!linked?.some((id) => String(id) === String(currentServiceId))) {
        payload.linkedServices = [
          ...linked,
          Number(currentServiceId) || currentServiceId,
        ];
      }
    }
    setRemainderSaving(true);
    const req = serviceRemainderId
      ? dispatch(
          updateServiceRemainderById({ serviceRemainderId, data: payload }),
        )
      : dispatch(createServiceRemainder(payload));
    req.then((res) => {
      setRemainderSaving(false);
      if (res?.payload) {
        refreshRemainders();
        handleCloseRemainderModal();
      }
    });
  };

  const handleConfirmLinkRemainder = () => {
    const tmp = (allRemainders ?? [])?.find(
      (item) => String(getRemainderId(item)) === String(pickedRemainder),
    );
    const serviceRemainderId = getRemainderId(tmp);
    if (!tmp || !serviceRemainderId || !currentServiceId || remainderSaving) {
      return;
    }
    setRemainderSaving(true);
    dispatch(
      updateServiceRemainderById({
        serviceRemainderId,
        data: buildRemainderPayload(tmp, [currentServiceId]),
      }),
    ).then((res) => {
      setRemainderSaving(false);
      if (res?.payload) {
        refreshRemainders();
        setAddRemainderOpen(false);
        setPickedRemainder("");
      }
    });
  };

  const buildDiagnosticTemplatePayload = (tmp, extraServiceIds = []) => {
    const existingIds = getTemplateLinkedIds(tmp);
    const linkedServices = [
      ...new Set(
        [...existingIds, ...extraServiceIds]
          ?.filter((id) => id != null && id !== "")
          ?.map((id) => (Number(id) ? Number(id) : id)),
      ),
    ];
    return {
      templateName: tmp?.templateName ?? tmp?.name ?? "",
      question: tmp?.question ?? tmp?.questions ?? [],
      content: tmp?.content ?? "",
      type: tmp?.type ?? "parameter",
      linkedServices,
    };
  };

  const handleOpenAddDiagnosticTemplate = () => {
    if (!currentServiceId) {
      dispatch(
        showSnackBar({
          message: "Save the service first to add a diagnostic template.",
          type: "warning",
        }),
      );
      return;
    }
    if (unlinkedDiagnosticOptions?.length > 0) {
      setPickedDiagTemp("");
      setAddDiagTempOpen(true);
      return;
    }
    handleCreateDiagnosticTemplate();
  };

  const handleCreateDiagnosticTemplate = () => {
    if (!currentServiceId) {
      dispatch(
        showSnackBar({
          message: "Save the service first to add a diagnostic template.",
          type: "warning",
        }),
      );
      return;
    }
    setAddDiagTempOpen(false);
    setPickedDiagTemp("");
    setSelectedDiagTemp({
      templateName: "",
      type: "parameter",
      linkedServices: [currentServiceId],
      question: [],
      content: "",
    });
    setDiagTempCreateVsble(true);
  };

  const handleEditDiagnosticTemplate = (tmp) => {
    setSelectedDiagTemp(tmp);
    setDiagTempCreateVsble(true);
  };

  const handleCloseDiagnosticTemplateCreate = () => {
    setDiagTempCreateVsble(false);
    setSelectedDiagTemp(null);
    refreshDiagnosticTemplates();
  };

  const handleSaveDiagnosticTemplate = (data) => {
    if (diagTempSaving) return;
    const payload = { ...(data ?? {}) };
    if (currentServiceId) {
      const linked = (payload?.linkedServices ?? [])?.map((id) =>
        Number(id) ? Number(id) : id,
      );
      if (!linked?.some((id) => String(id) === String(currentServiceId))) {
        payload.linkedServices = [
          ...linked,
          Number(currentServiceId) || currentServiceId,
        ];
      } else {
        payload.linkedServices = linked;
      }
    }
    const templateId = getDiagnosticTemplateId(selectedDiagTemp);
    setDiagTempSaving(true);
    const req = templateId
      ? dispatch(
          updateDiagnosticTemplateById({ tempId: templateId, data: payload }),
        )
      : dispatch(createDiagnosticTemplate(payload));
    req.then((res) => {
      setDiagTempSaving(false);
      if (res?.payload) {
        refreshDiagnosticTemplates();
        handleCloseDiagnosticTemplateCreate();
      }
    });
  };

  const handleConfirmLinkDiagnosticTemplate = () => {
    const tmp = (allDiagnosticTemplates ?? [])?.find(
      (item) =>
        String(getDiagnosticTemplateId(item)) === String(pickedDiagTemp),
    );
    const templateId = getDiagnosticTemplateId(tmp);
    if (!tmp || !templateId || !currentServiceId || diagTempSaving) return;
    setDiagTempSaving(true);
    dispatch(getDiagnosticTemplateByIdWoLoader(templateId))
      .then((detailRes) => {
        const full = detailRes?.payload ?? tmp;
        return dispatch(
          updateDiagnosticTemplateById({
            tempId: templateId,
            data: buildDiagnosticTemplatePayload(full, [currentServiceId]),
          }),
        );
      })
      .then((res) => {
        setDiagTempSaving(false);
        if (res?.payload) {
          refreshDiagnosticTemplates();
          setAddDiagTempOpen(false);
          setPickedDiagTemp("");
        }
      })
      .catch(() => {
        setDiagTempSaving(false);
      });
  };

  const buildFormPayload = (frm, extraServiceIds = []) => ({
    name: frm?.name ?? "",
    serviceType: frm?.serviceType ?? "",
    content: frm?.content ?? "",
    signed: frm?.signed ?? "false",
    linkedServices: mergeLinkedServiceIds(frm, extraServiceIds),
  });

  const buildCertificatePayload = (cert, extraServiceIds = []) => {
    const payload = {
      name: cert?.name ?? "",
      note: cert?.note ?? cert?.footerNote ?? DEFAULT_FOOTER_NOTE,
      linkedServices: mergeLinkedServiceIds(cert, extraServiceIds),
    };
    if (cert?.rabiesVaccination) {
      payload.rabiesVaccination = cert.rabiesVaccination;
    }
    if (cert?.parasiteTreatment) {
      payload.parasiteTreatment = cert.parasiteTreatment;
    }
    return payload;
  };

  const requireSavedService = (actionLabel) => {
    if (currentServiceId) return true;
    dispatch(
      showSnackBar({
        message: `Save the service first to ${actionLabel}.`,
        type: "warning",
      }),
    );
    return false;
  };

  const handleOpenAddForm = () => {
    if (!requireSavedService("add a consent form")) return;
    if (unlinkedFormOptions?.length > 0) {
      setPickedForm("");
      setAddFormOpen(true);
      return;
    }
    handleCreateForm();
  };

  const handleCreateForm = () => {
    if (!requireSavedService("add a consent form")) return;
    setAddFormOpen(false);
    setPickedForm("");
    setSelectedForm(null);
    setFormEditorValues({ name: "", serviceType: "Admission", content: "" });
    setFormEditorOpen(true);
  };

  const handleEditForm = (frm) => {
    setSelectedForm(frm);
    setFormEditorValues({
      name: frm?.name ?? "",
      serviceType: frm?.serviceType ?? "",
      content: frm?.content ?? "",
    });
    setFormEditorOpen(true);
  };

  const handleCloseFormEditor = () => {
    setFormEditorOpen(false);
    setSelectedForm(null);
    refreshForms();
  };

  const handleSaveFormEditor = () => {
    if (formSaving) return;
    if (!formEditorValues?.name?.trim() || !formEditorValues?.serviceType) {
      dispatch(
        showSnackBar({
          message: "Name and service type are required.",
          type: "warning",
        }),
      );
      return;
    }
    const formId = getFormId(selectedForm);
    const base = selectedForm ?? {};
    const data = buildFormPayload(
      {
        ...base,
        ...formEditorValues,
      },
      currentServiceId ? [currentServiceId] : [],
    );
    setFormSaving(true);
    const req = formId
      ? dispatch(updateFromById({ formId, data }))
      : dispatch(createClinicForm(data));
    req.then((res) => {
      setFormSaving(false);
      if (res?.payload) {
        refreshForms();
        handleCloseFormEditor();
      }
    });
  };

  const handleConfirmLinkForm = () => {
    const frm = (allForms ?? [])?.find(
      (item) => String(getFormId(item)) === String(pickedForm),
    );
    const formId = getFormId(frm);
    if (!frm || !formId || !currentServiceId || formSaving) return;
    setFormSaving(true);
    dispatch(
      updateFromById({
        formId,
        data: buildFormPayload(frm, [currentServiceId]),
      }),
    ).then((res) => {
      setFormSaving(false);
      if (res?.payload) {
        refreshForms();
        setAddFormOpen(false);
        setPickedForm("");
      }
    });
  };

  const handleOpenAddCertificate = () => {
    if (!requireSavedService("link a certificate")) return;
    if (unlinkedCertificateOptions?.length > 0) {
      setPickedCert("");
      setAddCertOpen(true);
      return;
    }
    dispatch(
      showSnackBar({
        message: "No certificates available to link.",
        type: "warning",
      }),
    );
  };

  const handleEditCertificate = (cert) => {
    setSelectedCert(cert);
    setCertEditorValues({
      name: cert?.name ?? "",
      note: cert?.note ?? cert?.footerNote ?? DEFAULT_FOOTER_NOTE,
    });
    setCertEditorOpen(true);
  };

  const handleCloseCertificateEditor = () => {
    setCertEditorOpen(false);
    setSelectedCert(null);
    refreshCertificates();
  };

  const handleSaveCertificateEditor = () => {
    if (certSaving) return;
    if (!certEditorValues?.name?.trim()) {
      dispatch(
        showSnackBar({
          message: "Certificate name is required.",
          type: "warning",
        }),
      );
      return;
    }
    const certificateId = getCertificateId(selectedCert);
    if (!certificateId) return;
    const base = selectedCert ?? {};
    const data = buildCertificatePayload(
      {
        ...base,
        ...certEditorValues,
      },
      currentServiceId ? [currentServiceId] : [],
    );
    setCertSaving(true);
    dispatch(updateClinicCertificateById({ certificateId, data })).then(
      (res) => {
        setCertSaving(false);
        if (res?.payload) {
          refreshCertificates();
          handleCloseCertificateEditor();
        }
      },
    );
  };

  const handleConfirmLinkCertificate = () => {
    const cert = (allCertificates ?? [])?.find(
      (item) => String(getCertificateId(item)) === String(pickedCert),
    );
    const certificateId = getCertificateId(cert);
    if (!cert || !certificateId || !currentServiceId || certSaving) return;
    setCertSaving(true);
    dispatch(
      updateClinicCertificateById({
        certificateId,
        data: buildCertificatePayload(cert, [currentServiceId]),
      }),
    ).then((res) => {
      setCertSaving(false);
      if (res?.payload) {
        refreshCertificates();
        setAddCertOpen(false);
        setPickedCert("");
      }
    });
  };

  useEffect(() => {
    if (selectedService) {
      appendServiceValues();
    }
  }, [selectedService]);

  useEffect(() => {
    if (!modVsble || !selectedService?.serviceId) return;
    refreshForms();
    refreshCertificates();
  }, [modVsble, selectedService?.serviceId]);

  const appendServiceValues = async () => {
    const slctedSer = servicesList?.data?.find(
      (product) => product?.serviceId === selectedService?.serviceId,
    );
    if (!slctedSer) return;
    const variants = (slctedSer?.serviceVariants ?? slctedSer?.variants)?.map(
      (vl, i) => {
        const varObj = {
          ...vl,
          servicePrice: Number(vl?.servicePrice)?.toFixed(2),
          serviceCharge: Number(vl?.serviceCharge)?.toFixed(2),
          delete: false,
          i,
          estimatedDuration: vl?.estimatedDuration ?? "",
          createdBy: vl?.createdBy ?? null,
        };
        let reqConsums = [],
          presLists = [],
          prescriptions = [];
        if (vl?.serviceDetails?.length > 0) {
          vl?.serviceDetails
            ?.filter(
              (li) =>
                (li?.alterType === "N" && !li?.alterName) ||
                (li?.alterType === "Y" && !li?.alterName),
            )
            ?.forEach((li) => {
              const batches = li?.stockId ? getBatches(li?.stockId) : [];
              const reqBat = li?.batchId
                ? (batches?.find((bt) => bt?.value === li?.batchId) ?? null)
                : null;
              const uomList = getUOMListByStockId(li?.stockId) ?? [];
              const reqUom =
                li?.uomId || li?.uomName
                  ? (uomList?.find(
                      (ul) =>
                        ul?.uomMappingId === li?.uomId ||
                        matchStrIgnoreCase(ul?.value, li?.uomName),
                    ) ?? null)
                  : null;
              const reqObj = {
                ...li,
                batchNumber: reqBat,
                uom: reqUom,
                cost: li?.estimatedCost ?? 0,
                estimatedCost: li?.estimatedCost ?? 0,
                delete: false,
              };
              reqConsums.push(reqObj);
            });
          const alters = vl?.serviceDetails?.filter(
            (li) => li?.alterType === "N" && li?.alterName,
          );
          const groupAlters = groupBy(alters, "alterName");
          reqConsums = reqConsums?.map((li) => {
            if (groupAlters?.[li?.name]?.length > 0) {
              const reqAlters = groupAlters?.[li?.name]?.map((al, i) => {
                const batches = al?.stockId ? getBatches(al?.stockId) : [];
                const reqBat = al?.batchId
                  ? (batches?.find((bt) => bt?.value === al?.batchId) ?? null)
                  : null;
                const uomList = getUOMListByStockId(al?.stockId) ?? [];
                const reqUom =
                  al?.uomId || al?.uomName
                    ? (uomList?.find(
                        (ul) =>
                          ul?.uomMappingId === al?.uomId ||
                          matchStrIgnoreCase(ul?.value, al?.uomName),
                      ) ?? null)
                    : null;
                return {
                  ...al,
                  batchNumber: reqBat,
                  uom: reqUom,
                  i,
                  isDefault: i === 0,
                  cost: al?.estimatedCost ?? 0,
                  estimatedCost: al?.estimatedCost ?? 0,
                  delete: false,
                };
              });
              return { ...li, alternates: reqAlters };
            }
            return li;
          });
        }
        varObj.consumList = reqConsums?.map((li, i) => ({ ...li, i }));
        if (vl?.servicePrescreiptions?.length > 0) {
          vl?.servicePrescreiptions
            ?.filter(
              (li) =>
                (li?.administered === "Administered" &&
                  li?.alterType === "N" &&
                  !li?.alterName) ||
                (li?.alterType === "Y" && !li?.alterName),
            )
            ?.forEach((li, i) => {
              const batches = li?.stockId ? getBatches(li?.stockId) : [];
              const reqBat = li?.batchId
                ? (batches?.find((bt) => bt?.value === li?.batchId) ?? null)
                : null;
              const uomList = getUOMListByStockId(li?.stockId) ?? [];
              const reqUom =
                li?.uomId || li?.uomName
                  ? (uomList?.find(
                      (ul) =>
                        ul?.uomMappingId === li?.uomId ||
                        matchStrIgnoreCase(ul?.value, li?.uomName),
                    ) ?? null)
                  : null;
              const reqObj = {
                prescriptionId: li?.prescriptionId,
                name: li?.name,
                stockId: li?.stockId,
                batchId: li?.batchId,
                quantity: li?.quantity,
                administered: "Administered",
                route: routeList?.find((rl) => rl?.value === li?.route) ?? null,
                dosage: li?.dosage,
                type: li?.type,
                duration: li?.duration,
                batchNumber: reqBat,
                uom: reqUom,
                delete: false,
                cost: li?.estimatedCost ?? 0,
                estimatedCost: li?.estimatedCost ?? 0,
              };
              presLists.push(reqObj);
            });
          const alters = vl?.servicePrescreiptions?.filter(
            (li) => li?.alterType === "N" && li?.alterName,
          );
          const groupAlters = groupBy(alters, "alterName");
          presLists = presLists?.map((li) => {
            if (groupAlters?.[li?.name]?.length > 0) {
              const reqAlters = groupAlters?.[li?.name]?.map((al, i) => {
                const batches = al?.stockId ? getBatches(al?.stockId) : [];
                const reqBat = al?.batchId
                  ? (batches?.find((bt) => bt?.value === al?.batchId) ?? null)
                  : null;
                const uomList = getUOMListByStockId(al?.stockId) ?? [];
                const reqUom =
                  al?.uomId || al?.uomName
                    ? (uomList?.find(
                        (ul) =>
                          ul?.uomMappingId === al?.uomId ||
                          matchStrIgnoreCase(ul?.value, al?.uomName),
                      ) ?? null)
                    : null;
                const reqObj = {
                  i,
                  isDefault: i === 0,
                  prescriptionId: al?.prescriptionId,
                  name: al?.name,
                  stockId: al?.stockId,
                  batchId: al?.batchId,
                  quantity: al?.quantity,
                  administered: "Administered",
                  route:
                    routeList?.find((rl) => rl?.value === al?.route) ?? null,
                  dosage: al?.dosage,
                  type: al?.type,
                  duration: al?.duration,
                  batchNumber: reqBat,
                  uom: reqUom,
                  delete: false,
                  cost: al?.estimatedCost ?? 0,
                  estimatedCost: al?.estimatedCost ?? 0,
                };
                return reqObj;
              });
              return { ...li, alternates: reqAlters };
            }
            return li;
          });

          vl?.servicePrescreiptions
            ?.filter((li) => li?.administered === "Prescribed")
            ?.forEach((li, i) => {
              const batches = li?.stockId ? getBatches(li?.stockId) : [];
              const reqFrequency =
                Array.isArray(li?.frequencyDuration) &&
                li?.frequencyDuration?.length > 0
                  ? li?.frequencyDuration?.map((fd) => frequencyEnum?.[fd])
                  : [];
              const reqObj = {
                prescriptionId: li?.prescriptionId,
                name: li?.name,
                stockId: li?.stockId,
                batchId: li?.batchId,
                quantity: li?.quantity,
                qty: li?.quantity,
                administered: "Prescribed",
                // route: routeList?.find((rl) => rl?.value === li?.vaccineType),
                dosage: li?.dosage,
                type: li?.type,
                duration: li?.duration,
                batchNumber: batches?.[0] ?? null,
                // cost: li?.estimatedCost,
                delete: false,
                frequency: reqFrequency,
                // frequency:
                //   li?.morning || li?.afternoon || li?.night
                //     ? [
                //         li?.morning && "morning",
                //         li?.afternoon && "afternoon",
                //         li?.night && "night",
                //       ]?.filter(Boolean)
                //     : li?.frequencyDuration?.length > 0
                //       ? li?.frequencyDuration
                //       : null,
                // customFrequency:
                //   !li?.morning &&
                //   !li?.afternoon &&
                //   !li?.night &&
                //   li?.frequencyDuration?.length > 0,
                meal: li?.meal,
                remark: li?.remark ?? "",
                cost: li?.estimatedCost ?? 0,
                estimatedCost: li?.estimatedCost ?? 0,
              };
              prescriptions.push(reqObj);
            });
          // const alters = vl?.servicePrescreiptions?.filter(
          //   (li) => li?.alterType === "N" && li?.alterName
          // );
          // const groupAlters = groupBy(alters, "alterName");
          // presLists = presLists?.map((li) => {
          //   if (groupAlters?.[li?.name]?.length > 0) {
          //     const reqAlters = groupAlters?.[li?.name]?.map((al, i) => {
          //       const batch = getBatchList(li?.stockId)?.[0];
          //       const reqObj = {
          //         i,
          //         isDefault: i === 0,
          //         prescriptionId: al?.prescriptionId,
          //         name: al?.name,
          //         stockId: al?.stockId,
          //         batchId: al?.batchId,
          //         quantity: al?.quantity,
          //         administered: "Administered",
          //         route: routeList?.find((rl) => rl?.value === al?.vaccineType),
          //         dosage: al?.dosage,
          //         type: al?.type,
          //         duration: al?.duration,
          //         batchNumber: batch,
          //         cost: al?.estimatedCost,
          //         delete: false,
          //       };
          //       return reqObj;
          //     });
          //     return { ...li, alternates: reqAlters };
          //   }
          //   return li;
          // });
        }
        varObj.presList = presLists?.map((li, i) => ({ ...li, i }));
        varObj.prescriptions =
          prescriptions?.length > 0
            ? prescriptions?.map((li, i) => ({ ...li, i }))
            : [];
        return varObj;
      },
    );
    const matchedCategory =
      serviceCategories?.find((cat) => cat?.value === slctedSer?.category) ??
      (slctedSer?.category
        ? { name: slctedSer.category, value: slctedSer.category }
        : null);
    const reqObj = {
      ...serviceValues,
      active: slctedSer?.active === "N",
      category: matchedCategory,
      subCategory: slctedSer?.subCategory
        ? { name: slctedSer?.subCategory, value: slctedSer?.subCategory }
        : null,
      serviceName: slctedSer?.serviceName,
      taxApplicability: slctedSer?.taxApplicability,
      tax: Number(slctedSer?.tax ?? 0),
      servicePrice: Number(slctedSer?.servicePrice)?.toFixed(2),
      serviceCharge: Number(slctedSer?.serviceCharge)?.toFixed(2),
      description: slctedSer?.description,
      hsnSacCode: slctedSer?.sacCode,
      variants,
      sampleType: slctedSer?.sampleType,
      doneAt: slctedSer?.doneAt,
      modality: slctedSer?.modality ?? null,
      region: slctedSer?.region ?? [],
      device: slctedSer?.device,
      processingTime: slctedSer?.processingTime,
      type: slctedSer?.type,
      diagnosticTemplate: null,
      nextDueValue: "",
      nextDueType: "day",
      linkedSubcategories: parseLinkedSubCategories(
        slctedSer?.linkedSubcategories ?? slctedSer?.linkedSubcategories ?? [],
        getAllLinkedStockSubCategoryOptions(stockCategories),
      ),
    };
    const reqDue = (slctedSer?.nextDueDate ?? "")?.match(/^(\d+)(.+)/);
    if (reqDue) {
      reqObj.nextDueValue = reqDue?.[1] ?? "";
      reqObj.nextDueType = reqDue?.[2] ?? "day";
    }
    if (slctedSer?.category === "Lab" || slctedSer?.category === "Radiology") {
      let tmplList = Array.isArray(mandateDiagnosticTemplates)
        ? mandateDiagnosticTemplates
        : [];
      if (!tmplList.length) {
        const res = await dispatch(
          getDiagnosticTemplatesWoLoader("?page=1&itemSize=1000"),
        );
        if (res?.payload != null) {
          tmplList = res?.payload?.list ?? res?.payload?.data ?? [];
          patchMandateSession({
            diagnosticTemplates: Array.isArray(tmplList) ? tmplList : [],
          });
        }
      }
      const matObj = tmplList?.find(
        (ob) => ob?.templateId === slctedSer?.diagnosticTemplateId,
      );
      if (matObj) {
        reqObj.diagnosticTemplate = {
          name: matObj?.templateName,
          value: matObj?.templateName,
          apiValue: matObj?.templateId ?? slctedSer?.diagnosticTemplateId,
        };
      }
    }
    setServiceValues(reqObj);
  };

  const handleClose = (typ) => {
    onCloseMod(typ);
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch?.map((btch) => ({
      name: btch?.batchNo,
      value: btch?.batchNo,
      batchId: btch?.batchId,
      salesUom: btch?.salesUom,
      unitSellingPrice: btch?.unitSellingPrice,
      purchaseUom: btch?.purchaseUom,
      packageUom: btch?.packageUom,
      dosage: btch?.dosage ?? "",
      dosageType: btch?.dosageType ?? null,
    }));
    return filteredBatches;
  };

  const handleSubmit = async () => {
    dispatch(showLoader());
    let errObj = {};
    let hlpObj = {};
    requiredFieldList?.forEach((fld) => {
      const reqValue =
        typeof serviceValues?.[fld] === "object"
          ? serviceValues?.[fld]?.value
          : serviceValues?.[fld];
      if (
        reqValue?.length === 0 ||
        (typeof reqValue === "number" && reqValue === 0) ||
        reqValue === undefined
      ) {
        errObj = {
          ...errObj,
          [fld]:
            // fld === "diagnosticTemplate"
            //   ? serviceValues?.category?.value === "Radiology" ||
            //     serviceValues?.category?.value === "Lab"
            //   :
            (fld === "tax" &&
              serviceValues?.taxApplicability?.toLowerCase() === "no") ||
            (fld === "modality" &&
              serviceValues?.category?.value !== "Radiology")
              ? false
              : true,
        };
        hlpObj = {
          ...hlpObj,
          [fld]:
            // fld === "diagnosticTemplate"
            //   ? serviceValues?.category?.value === "Radiology" ||
            //     serviceValues?.category?.value === "Lab"
            //     ? "This field is required"
            //     : ""
            //   :
            (fld === "tax" &&
              serviceValues?.taxApplicability?.toLowerCase() === "no") ||
            (fld === "modality" &&
              serviceValues?.category?.value !== "Radiology")
              ? ""
              : "This field is required",
        };
      } else {
        errObj = { ...errObj, [fld]: false };
        hlpObj = { ...hlpObj, [fld]: "" };
      }
      if (fld === "serviceCharge" || fld === "servicePrice") {
        if (
          Number(serviceValues?.[fld]) >= 0 ||
          serviceValues?.[fld]?.length === 0
        ) {
          errObj = {
            ...errObj,
            [fld]:
              serviceValues?.[fld] > 0
                ? Number(serviceValues?.[fld]) >= 0
                  ? false
                  : true
                : true,
          };
          hlpObj = {
            ...hlpObj,
            [fld]:
              serviceValues?.[fld]?.length > 0
                ? Number(serviceValues?.[fld]) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required",
          };
        }
      }
      if (fld === "subCategory") {
        if (serviceValues?.category?.value === "Radiology") {
          errObj = { ...errObj, subCategory: false };
          hlpObj = { ...hlpObj, subCategory: "" };
        }
      }
    });
    setServiceErrors({ ...serviceErrors, ...errObj });
    setServiceHelps({ ...serviceHelps, ...hlpObj });
    if (
      Object.keys(errObj)?.some((val) => errObj?.[val] === true) ||
      isVariantsNotValid()
    ) {
      dispatch(hideLoader());
      return;
    }

    const serviceVariants = serviceValues?.variants
      ?.filter((vl) => (vl?.createdBy ? vl?.createdBy === clinic?.id : true))
      ?.map((vl) => {
        const varObj = {
          variantName: vl?.variantName,
          serviceCharge: Number(vl?.serviceCharge)?.toFixed(2),
          servicePrice: Number(vl?.servicePrice)?.toFixed(2),
          variantNumber: vl?.variantNumber,
          estimatedDuration:
            vl?.estimatedDuration?.length > 0
              ? Number(vl?.estimatedDuration)
              : "",
          region: vl?.region ?? [],
          device: vl?.device ?? null,
          doneAt: vl?.doneAt ?? null,
        };
        if (vl?.variantId) varObj.variantId = vl?.variantId;
        varObj.delete = selectedService?.serviceId ? vl?.delete : false;
        let serviceDetailRequests = [];
        let servicePrescription = [];
        if (vl?.consumList?.length > 0) {
          vl?.consumList?.forEach((li) => {
            const reqObj = {
              name: li?.name,
              quantity: Number(li?.quantity),
              stockId: li?.stockId ?? null,
              estimatedCost: Number(li?.cost),
              batchId: null,
              batchNumber: "",
              uomId: li?.uom?.uomMappingId ?? null,
              uomName: li?.uom?.name ?? "",
            };
            // if (li?.stockId) {
            //   reqObj.batchId = getBatchList(li?.stockId)?.[0]?.batchId;
            // }
            if (li?.detailId) reqObj.detailId = li?.detailId;
            if (selectedService?.serviceId) {
              reqObj.delete = li?.delete;
            } else {
              reqObj.delete = false;
            }
            if (!li?.alternates || li?.alternates?.length === 0) {
              reqObj.alter = "N";
              serviceDetailRequests.push(reqObj);
            } else {
              reqObj.alter = "Y";
              serviceDetailRequests.push(reqObj);
              li?.alternates?.forEach((al) => {
                const altObj = {
                  name: al?.name,
                  quantity: Number(al?.quantity),
                  stockId: al?.stockId ?? null,
                  estimatedCost: Number(al?.cost),
                  alter: "N",
                  alterName: li?.name,
                  batchId: null,
                  batchNumber: "",
                  uomId: al?.uom?.uomMappingId ?? null,
                  uomName: al?.uom?.name ?? "",
                };
                // if (al?.stockId) {
                //   altObj.batchId = getBatchList(al?.stockId)?.[0]?.batchId;
                // }
                if (al?.detailId) altObj.detailId = al?.detailId;
                if (selectedService?.serviceId) {
                  altObj.delete = al?.delete;
                } else {
                  altObj.delete = false;
                }
                serviceDetailRequests.push(altObj);
              });
            }
          });
        }
        if (vl?.presList?.length > 0) {
          vl?.presList?.forEach((pre) => {
            const reqObj = {
              administered: "Administered",
              type: pre?.type ?? null,
              name: pre?.name ?? null,
              dosage: pre?.dosage ?? "",
              quantity: pre?.quantity ?? 1,
              route: pre?.route?.value ?? null,
              duration: "1",
              stockId: pre?.stockId ?? null,
              estimatedCost: Number(pre?.cost),
              batchId: null,
              batchNumber: "",
              uomId: pre?.uom?.uomMappingId ?? null,
              uomName: pre?.uom?.name ?? "",
            };
            // if (pre?.stockId) {
            //   reqObj.batchId = getBatchList(pre?.stockId)?.[0]?.batchId;
            // }
            if (pre?.prescriptionId)
              reqObj.prescriptionId = pre?.prescriptionId;
            if (selectedService?.serviceId) {
              reqObj.delete = pre?.delete;
            } else {
              reqObj.delete = false;
            }
            if (!pre?.alternates || pre?.alternates?.length === 0) {
              reqObj.alter = "N";
              servicePrescription.push(reqObj);
            } else {
              reqObj.alter = "Y";
              servicePrescription.push(reqObj);
              pre?.alternates?.forEach((al) => {
                const altObj = {
                  administered: "Administered",
                  type: al?.type ?? null,
                  name: al?.name ?? null,
                  dosage: al?.dosage ?? "",
                  quantity: al?.quantity ?? 1,
                  route: al?.route?.value ?? null,
                  duration: "1",
                  stockId: al?.stockId ?? null,
                  batchId: al?.batchId ?? null,
                  estimatedCost: Number(al?.cost),
                  alter: "N",
                  alterName: pre?.name,
                  batchId: null,
                  batchNumber: "",
                  uomId: al?.uom?.uomMappingId ?? null,
                  uomName: al?.uom?.name ?? "",
                };
                // if (al?.stockId) {
                //   altObj.batchId = getBatchList(al?.stockId)?.[0]?.batchId;
                // }
                if (al?.prescriptionId)
                  altObj.prescriptionId = al?.prescriptionId;
                if (selectedService?.serviceId) {
                  altObj.delete = al?.delete;
                } else {
                  altObj.delete = false;
                }
                servicePrescription.push(altObj);
              });
            }
          });
        }
        if (vl?.prescriptions?.length > 0) {
          vl?.prescriptions?.forEach((pre) => {
            const reqFreqList =
              Array.isArray(pre?.frequency) && pre?.frequency?.length > 0
                ? pre?.frequency?.map((fre) => frequencyConEnum[fre])
                : ["onceDaily"];
            const reqObj = {
              administered: "Prescribed",
              type: pre?.type ?? null,
              name: pre?.name ?? null,
              dosage: pre?.dosage,
              quantity: typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
              duration: pre?.duration ?? "1",
              stockId: pre?.stockId ?? null,
              batchId: pre?.batchNumber?.value ?? pre?.batchId ?? null,
              batchNumber: pre?.batchNumber?.name ?? "",
              estimatedCost: 0,
              meal: pre?.meal ?? "",
              morning:
                (reqFreqList?.length > 0 && reqFreqList?.includes("morning")) ??
                false,
              afternoon:
                (reqFreqList?.length > 0 &&
                  reqFreqList?.includes("afternoon")) ??
                false,
              night:
                (reqFreqList?.length > 0 && reqFreqList?.includes("night")) ??
                false,
              remark: pre?.remark ?? "",
              route: pre?.route?.value ?? null,
              frequencyDuration: reqFreqList ?? [],
            };
            // if (typeof pre?.frequency === "string") {
            //   reqObj.frequencyDuration = pre?.frequency;
            // }
            if (pre?.stockId) {
              reqObj.batchId = getBatchList(pre?.stockId)?.[0]?.batchId;
            }
            if (pre?.prescriptionId)
              reqObj.prescriptionId = pre?.prescriptionId;
            if (selectedService?.serviceId) {
              reqObj.delete = pre?.delete;
            } else {
              reqObj.delete = false;
            }
            servicePrescription.push(reqObj);
            // if (!pre?.alternates || pre?.alternates?.length === 0) {
            //   reqObj.alter = "N";
            //   servicePrescription.push(reqObj);
            // } else {
            //   reqObj.alter = "Y";
            //   servicePrescription.push(reqObj);
            //   pre?.alternates?.forEach((al) => {
            //     const altObj = {
            //       administered: "Administered",
            //       type: al?.type ?? null,
            //       name: al?.name ?? null,
            //       dosage: al?.dosage,
            //       quantity: 1,
            //       vaccineType: al?.route?.value,
            //       duration: "1",
            //       stockId: al?.stockId ?? null,
            //       batchId: al?.batchId ?? null,
            //       estimatedCost: Number(al?.cost),
            //       alter: "N",
            //       alterName: pre?.name,
            //     };
            //     if (al?.stockId) {
            //       altObj.batchId = getBatchList(al?.stockId)?.[0]?.batchId;
            //     }
            //     if (al?.prescriptionId)
            //       altObj.prescriptionId = al?.prescriptionId;
            //     if (serviceId) {
            //       altObj.delete = al?.delete;
            //     } else {
            //       altObj.delete = false;
            //     }
            //     servicePrescription.push(altObj);
            //   });
            // }
          });
        }
        varObj.serviceDetailRequests = serviceDetailRequests;
        varObj.servicePrescription = servicePrescription;
        return varObj;
      });

    // soapApiJson
    //   .post("/service", {
    //     service_name: serviceValues?.serviceName,
    //     service_details: {
    //       list: JSON.stringify(transformData(serviceValues?.variants)),
    //     },
    //   })
    //   .then((res) => {
    let serviceDescription = "",
      serviceVector = [];
    // if (res?.status === 200) {
    //   if (res?.data) {
    //     serviceDescription = res?.data?.ServiceDescription;
    //     serviceVector = res?.data?.ServiceVector;
    //   }
    dispatch(showLoader());
    const serviceData = {
      active: serviceValues?.active ? "N" : "Y",
      type: serviceValues?.type,
      categoryType: serviceValues?.type,
      category: serviceValues?.category?.value,
      subCategory:
        serviceValues?.category?.value === "Radiology"
          ? null
          : serviceValues?.subCategory?.value,
      serviceName: String(serviceValues?.serviceName ?? "").trim(),
      modality: serviceValues?.modality ?? null,
      taxApplicability: serviceValues?.taxApplicability,
      tax:
        serviceValues?.taxApplicability?.toLowerCase() === "yes"
          ? Number(serviceValues?.tax ?? 0)
          : 0,
      servicePrice: Number(
        Number(serviceVariants?.[0]?.servicePrice ?? 0) +
          Number(
            getTotalEstimatedCost([
              ...(serviceVariants?.[0]?.consumList ?? []),
              ...(serviceVariants?.[0]?.presList ?? []),
            ]) ?? 0,
          ),
      )?.toFixed(2),
      serviceCharge: Number(serviceVariants?.[0]?.serviceCharge)?.toFixed(2),
      description: serviceValues?.description,
      internalDescription: serviceDescription,
      serviceVector: serviceVector,
      hsnSacCode: serviceValues?.hsnSacCode,
      nextDueDate:
        `${serviceValues?.nextDueValue}${serviceValues?.nextDueType}` ?? "",
      linkedSubcategories: (serviceValues?.linkedSubcategories ?? [])?.map(
        (sc) => sc?.value ?? sc?.name,
      ),
      serviceVariants,
    };
    if (
      serviceValues?.category?.value === "Lab" ||
      serviceValues?.category?.value === "Radiology"
    ) {
      serviceData.doneAt = serviceValues?.doneAt;
      serviceData.processingTime = serviceValues?.processingTime;
      if (serviceValues?.diagnosticTemplate?.apiValue) {
        serviceData.diagnosticTemplateId =
          serviceValues?.diagnosticTemplate?.apiValue;
      }
      if (serviceValues?.category?.value === "Lab") {
        serviceData.sampleType = serviceValues?.sampleType;
      }
    }
    try {
      if (selectedService?.serviceId) {
        dispatch(
          editClinicService({
            id: selectedService?.serviceId,
            data: serviceData,
          }),
        ).then((res) => {
          if (res?.payload) {
            dispatch(hideLoader());
            handleClose("apiSuccess");
            setItemErrors({
              consumList: [],
              presList: [],
            });
            dispatch(
              getServicesWoLoader(`?serviceData=${dataSharing?.serviceData}`),
            ).then((serRes) => {
              if (serRes?.payload) {
                patchMandateSession({
                  services: serRes?.payload?.data ?? [],
                });
              }
            });
          }
          dispatch(hideLoader());
        });
      } else {
        dispatch(createClinicService(serviceData)).then((res) => {
          if (res?.payload) {
            dispatch(hideLoader());
            handleClose("apiSuccess");
            setItemErrors({
              consumList: [],
              presList: [],
            });
            setServiceValues(initialValues);
            dispatch(
              getServicesWoLoader(`?serviceData=${dataSharing?.serviceData}`),
            ).then((serRes) => {
              if (serRes?.payload) {
                patchMandateSession({
                  services: serRes?.payload?.data ?? [],
                });
              }
            });
          }
          dispatch(hideLoader());
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      console.error("Error:", error);
    }
    //   } else {
    //     dispatch(hideLoader());
    //   }
    // });
  };

  const handleDeleteVariant = (ind) => {
    const isVisibleVariant = (li) =>
      !li?.delete && (li?.createdBy ? li?.createdBy === clinic?.id : true);

    const visibleVariants =
      serviceValues?.variants?.filter(isVisibleVariant) ?? [];
    if (visibleVariants.length <= 1) return;

    const target = serviceValues?.variants?.find((li) => li?.i === ind);
    if (!target || !isVisibleVariant(target)) return;

    const reqObj = { ...serviceValues };
    if (target?.variantId) {
      reqObj.variants = serviceValues?.variants?.map((li) => {
        if (li?.i !== ind) return li;
        const reqConList = li?.consumList?.map((cl) => {
          const reqAlters = (cl?.alternates ?? [])
            ?.filter((al) => !al?.detailId && al?.delete)
            ?.map((al) => ({ ...al, delete: true }));
          return { ...cl, delete: true, alternates: reqAlters };
        });
        const reqPresList = li?.presList?.map((pl) => {
          const reqAlters = (pl?.alternates ?? [])
            ?.filter((al) => !al?.detailId && al?.delete)
            ?.map((al) => ({ ...al, delete: true }));
          return { ...pl, delete: true, alternates: reqAlters };
        });
        return {
          ...li,
          delete: true,
          consumList: reqConList,
          presList: reqPresList,
        };
      });
    } else {
      reqObj.variants = serviceValues?.variants
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
    }
    setServiceValues(reqObj);
  };

  const checkEstDurationIsMandatory = () => {
    let result = false;
    if (
      (serviceValues?.category?.value === "Radiology" &&
        (serviceValues?.subCategory?.value === "Imaging" ||
          serviceValues?.subCategory?.value === "Endoscopy")) ||
      (serviceValues?.category?.value === "Hygiene & Grooming" &&
        (serviceValues?.subCategory?.value === "Bathing" ||
          serviceValues?.subCategory?.value === "Spa/Pampering Services"))
    ) {
      result = true;
    }
    return result;
  };

  const isVariantsNotValid = () => {
    const reqVariants = serviceValues?.variants
      ?.filter((li) => (li?.createdBy ? li?.createdBy === clinic?.id : true))
      ?.map((vl) => {
        const reqObj = { ...vl };
        if (vl?.variantName?.length === 0 || !vl?.variantName) {
          reqObj.nameErr = "This field is required";
        }
        if (
          vl?.serviceCharge === undefined ||
          vl?.serviceCharge === null ||
          vl?.serviceCharge === "" ||
          Number(vl?.serviceCharge) < 0
        ) {
          reqObj.chargeErr =
            vl?.serviceCharge?.length === 0
              ? "This field is required"
              : "Value must be positive";
        }
        if (
          vl?.servicePrice === undefined ||
          vl?.servicePrice === null ||
          vl?.servicePrice === "" ||
          Number(vl?.servicePrice) < 0 ||
          Number(vl?.servicePrice) < Number(vl?.serviceCharge)
        ) {
          reqObj.serPriceErr =
            vl?.servicePrice?.length > 0
              ? Number(vl?.servicePrice) < Number(vl?.serviceCharge)
                ? "Value must be greater than or equal to Service Charge"
                : "Value must be positive"
              : "This field is required";
        }
        if (
          serviceValues?.category?.value === "Radiology" &&
          (!vl?.region || vl?.region?.length === 0)
        ) {
          reqObj.regionErr = "This field is required";
        }
        if (checkEstDurationIsMandatory() && !vl?.estimatedDuration) {
          if (
            !vl?.estimatedDuration ||
            vl?.estimatedDuration?.length === 0 ||
            Number(vl?.estimatedDuration) < 0
          ) {
            reqObj.durError =
              vl?.estimatedDuration?.length > 0
                ? "Value must be positive"
                : "This field is required";
          }
        }
        return reqObj;
      });
    setServiceValues({ ...serviceValues, variants: reqVariants });

    return reqVariants?.some(
      (variant) =>
        variant?.nameErr?.length > 0 ||
        variant?.chargeErr?.length > 0 ||
        variant?.serPriceErr?.length > 0 ||
        variant?.durError?.length > 0,
    );
  };

  const onChangeVarValue = (name, value, ind) => {
    const reqObj = {
      ...serviceValues,
      variants: serviceValues?.variants?.map((li) => {
        if (li?.i === ind) {
          const newObj = { ...li, [name]: value };
          if (name === "variantName") {
            newObj.nameErr = value?.length > 0 ? "" : "This field is required";
          }
          if (name === "estimatedDuration") {
            newObj.durError =
              value?.length > 0
                ? Number(value) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required";
          }
          if (name === "serviceCharge") {
            newObj.chargeErr =
              value?.length > 0
                ? Number(value) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required";
            newObj.serPriceErr =
              value?.length > 0
                ? Number(value) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required";
            const reqSellPrce =
              Number(value) +
              getTotalEstimatedCost([
                ...(li?.consumList ?? []),
                ...(li?.presList ?? []),
              ]);
            newObj.servicePrice = reqSellPrce;
            if (
              getTotalEstimatedCost([
                ...(li?.consumList ?? []),
                ...(li?.presList ?? []),
              ]) >= Number(value)
            ) {
              newObj.serPriceErr = "";
            }
          }
          if (name === "servicePrice") {
            newObj.serPriceErr =
              value?.length > 0
                ? Number(value) < 0
                  ? "Value must be positive"
                  : Number(value) >= Number(newObj.serviceCharge)
                    ? ""
                    : "Value must be greater than or equal to Service Charge"
                : "This field is required";
          }
          if (name === "region") {
            newObj.regionErr =
              value?.length > 0 ? "" : "This field is required";
          }
          return newObj;
        }
        return li;
      }),
    };

    setServiceValues(reqObj);
  };

  const handleChange = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...serviceValues, [name]: value };
    let errObj = { ...serviceErrors, [name]: false };
    let hlpObj = { ...serviceHelps, [name]: "" };
    if (reqValue?.length > 0) {
      if (name === "type") {
        reqObj.taxApplicability = value === "Medical" ? "No" : "Yes";
        reqObj.category = null;
        reqObj.subCategory = null;
      }
      if (name === "category") {
        // if (value?.value === "Lab" || value?.value === "Radiology") {
        //   dispatch(getClinicFacilitiesWoLoader());
        // }
        reqObj.subCategory = null;
        if (value?.value === "Lab" || value?.value === "Radiology") {
          refreshDiagnosticTemplates();
        }
      }
      if (name === "serviceCharge" || name === "servicePrice") {
        errObj = {
          ...errObj,
          [name]:
            reqValue?.length > 0
              ? Number(reqValue) >= 0
                ? false
                : true
              : true,
        };
        hlpObj = {
          ...hlpObj,
          [name]:
            reqValue?.length > 0
              ? Number(reqValue) >= 0
                ? ""
                : "Value must be positive"
              : "This field is required",
        };
      }
    } else {
      errObj = {
        ...errObj,
        [name]: requiredFieldList?.includes(name) ? true : false,
      };
      hlpObj = {
        ...hlpObj,
        [name]: requiredFieldList?.includes(name)
          ? "This field is required"
          : "",
      };
    }
    if (name === "modality") {
      reqObj.region = [];
    }
    if (name === "region") {
      errObj = {
        ...errObj,
        [name]: value?.length > 0 ? false : true,
      };
      hlpObj = {
        ...hlpObj,
        [name]: value?.length > 0 ? "" : "This field is required",
      };
    }
    setServiceHelps(hlpObj);
    setServiceErrors(errObj);
    setServiceValues(reqObj);
  };

  const getServiceCategories = () => {
    if (!Array.isArray(serviceCategories)) return [];
    const selectedType =
      typeof serviceValues?.type === "object"
        ? serviceValues?.type?.value
        : serviceValues?.type;
    if (!selectedType) return [];
    return serviceCategories.filter(
      (cat) => cat?.categoryType === selectedType,
    );
  };

  const handleLinkedSubCategoryChange = (e) => {
    setServiceValues({
      ...serviceValues,
      linkedSubcategories: e?.target?.value ?? [],
    });
  };

  const removeLinkedSubCategory = (value) => {
    setServiceValues({
      ...serviceValues,
      linkedSubcategories: (serviceValues?.linkedSubcategories ?? [])?.filter(
        (sc) => sc?.value !== value,
      ),
    });
  };

  const getDiagnosticTemplateList = () => {
    return (allDiagnosticTemplates ?? [])?.map((li) => ({
      name: li?.templateName,
      value: li?.templateName,
      apiValue: li?.templateId,
    }));
  };

  const getRegionListBasedOnModality = (modality = null) => {
    if (modality) {
      return regionList?.filter((li) => li?.modality === modality);
    }
    return [];
  };

  const addVariant = () => {
    const reqObj = { ...serviceValues };
    const prevVariants = serviceValues?.variants ?? [];
    const clinicVariants = serviceValues?.variants?.filter((vr) =>
      vr?.createdBy ? vr?.createdBy === clinic?.id : true,
    );
    prevVariants.push({
      ...(clinicVariants?.[0] ?? {}),
      variantId: "",
      variantNumber: "",
      variantName: "",
      serviceCharge: "",
      servicePrice: "",
      i: prevVariants?.length ?? 0,
    });
    reqObj.variants = prevVariants;
    setServiceValues(reqObj);
  };

  const validateConsumItem = (item) => {
    const errors = {};
    if (!item?.name || item?.name?.length === 0)
      errors.nameErr = "Name is required";
    if (!item?.quantity || Number(item?.quantity) < 1)
      errors.quantity = "Valid quantity is required";
    return errors;
  };

  const validatePresItem = (item) => {
    const errors = {};
    if (!item?.name || item?.name?.length === 0)
      errors.nameErr = "Name is required";
    if (!item?.quantity || Number(item?.quantity) < 1)
      errors.quantity = "Valid quantity is required";
    return errors;
  };

  const validatePrescripItem = (item) => {
    const errors = {};
    if (!item?.name || item?.name?.length === 0)
      errors.nameErr = "Name is required";
    // if (!item?.qty || Number(item?.qty) < 1)
    //   errors.qtyErr = "Valid Quantity is required";
    return errors;
  };

  const handleView = (dta) => {
    const reqVarnts = serviceValues?.variants?.map((li) => {
      if (li?.i === dta?.i) return { ...li, modVsble: true };
      return li;
    });
    setVariantValues({
      ...variantValues,
      consumList: dta?.consumList ?? [],
      presList: dta?.presList ?? [],
      prescriptions: dta?.prescriptions ?? [],
    });
    setSlctedVariant(dta);
    setServiceValues({ ...serviceValues, variants: reqVarnts });
  };

  const saveVariant = () => {
    let isValueErr = false;
    const reqVariants = serviceValues?.variants?.map((li) => {
      if (li?.i === slctedVariant?.i) {
        const reqObj = { ...li };
        if (variantValues?.consumList?.length > 0) {
          reqObj.consumList = variantValues?.consumList?.map((cl) => {
            const errs = validateConsumItem(cl);
            return { ...cl, ...errs };
          });
        }
        if (variantValues?.presList?.length > 0) {
          reqObj.presList = variantValues?.presList?.map((pl) => {
            const errs = validatePresItem(pl);
            return { ...pl, ...errs };
          });
        }
        if (variantValues?.prescriptions?.length > 0) {
          reqObj.prescriptions = variantValues?.prescriptions?.map((pl) => {
            const errs = validatePrescripItem(pl);
            return { ...pl, ...errs };
          });
        }
        if (
          reqObj?.consumList?.some(
            (li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0,
          ) ||
          reqObj?.presList?.some(
            (li) =>
              li?.nameErr?.length > 0 ||
              li?.dosErr?.length > 0 ||
              li?.routeErr?.length > 0,
          ) ||
          reqObj?.prescriptions?.some(
            (li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0,
          )
        ) {
          isValueErr = true;
          setVariantValues({
            ...variantValues,
            consumList: reqObj?.consumList,
            presList: reqObj?.presList,
            prescriptions: reqObj?.prescriptions,
          });
        }
        const reqSellPrce =
          Number(li?.serviceCharge ?? 0) +
          getTotalEstimatedCost([
            ...(variantValues?.consumList ?? []),
            ...(variantValues?.presList ?? []),
          ]);
        reqObj.servicePrice = reqSellPrce;
        return reqObj;
      }
      return li;
    });
    if (isValueErr) return;
    setServiceValues({ ...serviceValues, variants: reqVariants });
    setVariantValues(initVariants);
    setSlctedVariant(null);
    dispatch(
      showSnackBar({
        message: "Changes updated successfully!",
        type: "success",
      }),
    );
  };

  const getStockBatch = (stockId, batchId) => {
    const selStock = stocks?.find((stc) => stc?.stockId === stockId);
    const reqBatc = selStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId,
    );
    return reqBatc;
  };

  const handleAddTask = (typ) => {
    let consumList = variantValues?.consumList;
    let presList = variantValues?.presList;
    let prescriptions = variantValues?.prescriptions;
    if (typ === "consum") {
      const reqList = [
        ...variantValues?.consumList,
        { ...initItem, i: variantValues?.consumList?.length },
      ];
      consumList = reqList;
    }
    if (typ === "pres") {
      const reqList = [
        ...variantValues?.presList,
        { ...initItem, i: variantValues?.presList?.length },
      ];
      presList = reqList;
    }
    if (typ === "prescriptions") {
      const reqList = [
        ...(variantValues?.prescriptions ?? []),
        { ...initItem, i: variantValues?.prescriptions?.length ?? 0 },
      ];
      prescriptions = reqList;
    }
    setVariantValues({ ...variantValues, consumList, presList, prescriptions });
  };

  const getList = (isPres = false) => {
    let reqList = [];
    if (isPres) {
      reqList = stocks?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          // dta?.billable &&
          (dta?.category?.toLowerCase() === "deworming" ||
            dta?.category?.toLowerCase() === "diet" ||
            dta?.category?.toLowerCase() === "flea & tick treatment" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "medication" ||
            dta?.category?.toLowerCase() === "nutrition and supplements" ||
            dta?.category?.toLowerCase() === "other parasite treatment" ||
            dta?.category?.toLowerCase() === "vaccines")
        );
      });
    } else {
      reqList = stocks?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          // dta?.billable &&
          (dta?.category?.toLowerCase() === "general consumables" ||
            dta?.category?.toLowerCase() === "medical supplies" ||
            dta?.category?.toLowerCase() === "surgical supplies" ||
            dta?.category?.toLowerCase() === "lab consumables" ||
            dta?.category?.toLowerCase() === "lab supplies" ||
            dta?.category?.toLowerCase() === "cleaning supplies" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "mortuary")
        );
      });
    }
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const handleVariantClose = (dta) => {
    const reqVarnts = serviceValues?.variants?.map((li) => {
      if (li?.i === slctedVariant?.i) {
        return { ...li, modVsble: false };
      }
      return li;
    });
    setSlctedVariant(null);
    setServiceValues({ ...serviceValues, variants: reqVarnts });
  };

  const handleConsumChange = (name, value, ind, addObj) => {
    const reqList = variantValues?.consumList?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.nameErr = "";
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.serviceId = addObj?.serviceId;
          reqObj.category = addObj?.category;
          if (addObj?.stockId) {
            const reqBatch = addObj?.batchId
              ? getStockBatch(addObj?.stockId, addObj?.batchId)
              : stocks?.find((stc) => stc?.stockId === addObj?.stockId)
                  ?.stockBatch?.[0];
            let reqCost = 0;
            if (reqBatch && addObj?.stockId) {
              const reqQty = Number(reqObj?.quantity ?? 1);
              const uomList = getUOMListByStockId(addObj?.stockId);
              const reqUom = uomList?.[0];
              reqObj.uom = reqUom;
              const matchedUom = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqUom?.uomMappingId ||
                  matchStrIgnoreCase(ul?.value, reqUom?.name),
              );
              const batUomMatch = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqBatch?.mapId ||
                  matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
              );
              const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
              const reqPrice =
                Number(
                  Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
                ) * Number(matchedUom?.conversion ?? 1);
              reqCost = Number(reqPrice) * Number(reqQty);
            }
            reqObj.cost = reqCost;
            reqObj.batchNumber = reqBatch
              ? { name: reqBatch?.batchNo, value: reqBatch?.batchId }
              : null;
          }
          if (addObj?.serviceId) {
            const reqService = servicesList?.data?.find(
              (ser) => ser?.serviceId === addObj?.serviceId,
            );
            if (reqService) reqObj.cost = reqService?.servicePrice;
          }
        }
        if (name === "quantity") {
          reqObj.qtyErr = value?.length > 0 ? "" : "This field is required";
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === li?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, li?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (li?.serviceId) {
            reqObj.cost =
              (Number(
                servicesList?.data?.find(
                  (ser) => ser?.serviceId === li?.serviceId,
                )?.servicePrice,
              ) ?? 0) * (Number(value) ?? 1);
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "uom") {
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "batchNumber" && value?.value) {
          reqObj.batchId = value?.value;
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (li?.stockId) {
            const reqBatch = value?.value
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === value?.value)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        return reqObj;
      }
      return li;
    });
    setVariantValues({ ...variantValues, consumList: reqList });
  };

  const handleConsumDelete = (ind, detailId = null) => {
    let reqList = [];
    if (selectedService?.serviceId && detailId) {
      reqList = variantValues?.consumList?.map((li, i) => {
        if (i === ind) {
          const reqAlter = (li?.alternates ?? [])
            ?.filter((al) => al?.delete && !al?.detailId)
            ?.map((al) => ({ ...al, delete: true }));
          return { ...li, delete: true, alternates: reqAlter };
        }
        return li;
      });
    } else {
      reqList = variantValues?.consumList
        ?.filter((li, i) => i !== ind)
        ?.map((li, i) => {
          return { ...li, i };
        });
    }
    setVariantValues({ ...variantValues, consumList: reqList });
  };

  const getPresList = () => {
    const reqList = stocks?.filter((dta) => {
      return (
        dta?.active === "Y" &&
        dta?.billable &&
        (dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "nutrition and supplements" ||
          dta?.category?.toLowerCase() === "fluid therapy" ||
          dta?.category?.toLowerCase() === "other parasite treatment" ||
          dta?.category?.toLowerCase() === "deworming" ||
          dta?.category?.toLowerCase() === "flea & tick treatment" ||
          dta?.category?.toLowerCase() === "grooming & hygiene care")
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const handleSaveConsum = () => {
    const reqCon = getOpenedConsum();
    const reqObj = { ...variantValues };
    const reqAlters = alternates?.map((al) => {
      const errs = validateConsumItem(al);
      return { ...al, ...errs };
    });
    if (
      reqAlters?.some((li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0)
    ) {
      return setAlternates(reqAlters);
    }
    reqObj.consumList = variantValues?.consumList?.map((li) => {
      if (li?.i === reqCon?.i) {
        const reqAlts = reqAlters?.sort((a, b) => b?.isDefault - a?.isDefault);
        const reqInnerObj = { ...li, modVsble: false, alternates: reqAlts };
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
    setAlternates([]);
    dispatch(
      showSnackBar({
        message: "Changes updated successfully!",
        type: "success",
      }),
    );
  };

  const handleSaveAdmin = () => {
    const reqAdm = getOpenedAdmin();
    const reqObj = { ...variantValues };
    const reqAlters = alternates?.map((al) => {
      const errs = validatePresItem(al);
      return { ...al, ...errs };
    });
    if (
      reqAlters?.some((li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0)
    ) {
      return setAlternates(reqAlters);
    }
    reqObj.presList = variantValues?.presList?.map((li) => {
      if (li?.i === reqAdm?.i) {
        const reqAlts = alternates?.sort((a, b) => b?.isDefault - a?.isDefault);
        const reqInnerObj = { ...li, modVsble: false, alternates: reqAlts };
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
    setAlternates([]);
    dispatch(
      showSnackBar({
        message: "Changes updated successfully!",
        type: "success",
      }),
    );
  };

  const deletePricripByIndex = (ind, presId = null) => {
    let reqList = [];
    if (selectedService?.serviceId && presId) {
      reqList = variantValues?.prescriptions?.map((rl, i) => {
        if (i === ind) {
          return { ...rl, delete: true };
        }
        return rl;
      });
    } else {
      reqList = variantValues?.prescriptions
        ?.filter((pre, i) => {
          return i !== ind;
        })
        ?.map((rl, i) => ({ ...rl, i }));
    }
    setVariantValues({ ...variantValues, prescriptions: reqList });
  };

  const handleChangePrescripValue = (name, value, ind, addObj) => {
    const reqList = variantValues?.prescriptions?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "name" && addObj) {
          reqObj.nameErr = "";
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = stocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            )?.stockBatch?.[0];
            const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
            reqObj.dosage =
              getBatchList(addObj?.stockId)?.[0]?.dosage ?? reqPack?.[1];
            reqObj.cost = Number(reqBatch?.unitSellingPrice) ?? 0;
          } else {
            reqObj.cost = 0;
          }
        }
        if (name === "batchNumber" && value?.value) {
          reqObj.batchId = value?.value;
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (pl?.stockId) {
            const reqBatch = value?.value
              ? stocks
                  ?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === value?.value)
              : stocks?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!pl?.stockId && !pl?.batchId && !pl?.serviceId) {
            const reqCost =
              Number(pl?.initCost ?? pl?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (name === "route") {
          reqObj.routeErr = !value ? "This field is required" : "";
        }
        if (name === "qty") {
          reqObj.qtyErr =
            value?.length > 0
              ? Number(value) > 0
                ? ""
                : "Value must be positive"
              : "This field is reqired";
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setVariantValues({ ...variantValues, prescriptions: reqList });
  };

  const deleteAdministerByIndex = (ind, presId = null) => {
    let reqList = [];
    if (selectedService?.serviceId && presId) {
      reqList = variantValues?.presList?.map((rl, i) => {
        if (i === ind) {
          const reqAlters = (rl?.alternates ?? [])
            ?.filter((al) => al?.delete && !al?.prescriptionId)
            ?.map((al) => ({ ...al, delete: true }));
          return { ...rl, delete: true, alternates: reqAlters };
        }
        return rl;
      });
    } else {
      reqList = variantValues?.presList
        ?.filter((pre, i) => {
          return i !== ind;
        })
        ?.map((rl, i) => ({ ...rl, i }));
    }
    setVariantValues({ ...variantValues, presList: reqList });
  };

  const handleChangeAdminsterValue = (name, value, ind, addObj) => {
    const reqList = variantValues?.presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "name" && addObj) {
          const reqQty = Number(reqObj?.quantity ?? 1);
          reqObj.nameErr = "";
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = stocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            )?.stockBatch?.[0];
            let reqCost = 0;
            if (reqBatch && addObj?.stockId) {
              const reqQty = Number(reqObj?.quantity ?? 1);
              const uomList = getUOMListByStockId(addObj?.stockId);
              const reqUom = uomList?.[0];
              reqObj.uom = reqUom;
              const matchedUom = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqUom?.uomMappingId ||
                  matchStrIgnoreCase(ul?.value, reqUom?.name),
              );
              const batUomMatch = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqBatch?.mapId ||
                  matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
              );
              const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
              const reqPrice =
                Number(
                  Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
                ) * Number(matchedUom?.conversion ?? 1);
              reqCost = Number(reqPrice) * Number(reqQty);
            }
            reqObj.cost = reqCost;
            reqObj.batchNumber = reqBatch
              ? { name: reqBatch?.batchNo, value: reqBatch?.batchId }
              : null;
          }
          // if (pl?.dosage) {
          //   if (addObj?.stockId) {
          //     const reqBatch = stocks?.find(
          //       (stc) => stc?.stockId === addObj?.stockId,
          //     )?.stockBatch?.[0];
          //     const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          //     const priceRatio = Number(pl?.dosage ?? 0) / Number(reqPack?.[1]);
          //     const reqPrice =
          //       (Number(reqBatch?.unitSellingPrice) ?? 0) *
          //       Number(priceRatio ?? 0);
          //     reqObj.cost = reqPrice;
          //   }
          // }
        }
        if (name === "quantity") {
          reqObj.qtyErr = value?.length > 0 ? "" : "This field is required";
          if (pl?.stockId) {
            const reqBatch = pl?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === pl?.batchId)
              : stocks?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === pl?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, pl?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!pl?.stockId && !pl?.batchId && !pl?.serviceId) {
            const reqCost =
              Number(pl?.initCost ?? pl?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "uom") {
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (pl?.stockId) {
            const reqBatch = pl?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === pl?.batchId)
              : stocks?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!pl?.stockId && !pl?.batchId && !pl?.serviceId) {
            const reqCost =
              Number(pl?.initCost ?? pl?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "batchNumber" && value?.value) {
          reqObj.batchId = value?.value;
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (pl?.stockId) {
            const reqBatch = value?.value
              ? stocks
                  ?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === value?.value)
              : stocks?.find((stc) => stc?.stockId === pl?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!pl?.stockId && !pl?.batchId && !pl?.serviceId) {
            const reqCost =
              Number(pl?.initCost ?? pl?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (name === "route") {
          reqObj.routeErr = !value ? "This field is required" : "";
        }
        // if (name === "dosage") {
        //   reqObj.dosErr =
        //     value?.length > 0
        //       ? Number(value) > 0
        //         ? ""
        //         : "Value must be positive"
        //       : "This field is reqired";
        //   if (pl?.stockId) {
        //     const reqBatch = stocks?.find((stc) => stc?.stockId === pl?.stockId)
        //       ?.stockBatch?.[0];
        //     const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
        //     const priceRatio = Number(value) / Number(reqPack?.[1]);
        //     const reqPrice =
        //       (Number(reqBatch?.unitSellingPrice) ?? 0) *
        //       Number(priceRatio ?? 0);
        //     reqObj.cost = reqPrice;
        //   }
        // }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setVariantValues({ ...variantValues, presList: reqList });
  };

  const handleConsumAlternates = (ind, value) => {
    const reqObj = { ...variantValues };
    reqObj.consumList = variantValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        const reqInnerObj = { ...li, modVsble: value };
        setAlternates(
          !li?.alternates || li?.alternates?.length === 0
            ? [{ ...li, isDefault: true, i: 0 }]
            : li?.alternates,
        );
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
  };

  const getOpenedConsum = () => {
    return variantValues?.consumList?.find((li) => li?.modVsble);
  };

  const getOpenedAdmin = () => {
    return variantValues?.presList?.find((li) => li?.modVsble);
  };

  const onCloseConsumMod = () => {
    const reqCon = getOpenedConsum();
    if (reqCon) handleConsumAlternates(reqCon?.i, false);
  };

  const onCloseAdminMod = () => {
    const reqAdmn = getOpenedAdmin();
    if (reqAdmn) handleAdminAlternates(reqAdmn?.i, false);
  };

  const handleAdminAlternates = (ind, value) => {
    const reqObj = { ...variantValues };
    reqObj.presList = variantValues?.presList?.map((li) => {
      if (li?.i === ind) {
        const reqInnerObj = { ...li, modVsble: value };
        setAlternates(
          !li?.alternates || li?.alternates?.length === 0
            ? [{ ...li, isDefault: true, i: 0 }]
            : li?.alternates,
        );
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
  };

  const onChangeConsumDefault = (ind) => {
    const reqCon = getOpenedConsum();
    const reqVar = alternates?.find((li) => li?.i === ind);
    const reqAlternates = alternates?.map((li) => ({
      ...li,
      isDefault: li?.i === ind,
    }));
    const reqConsumList = variantValues?.consumList?.map((li) => {
      if (li?.i === reqCon?.i) {
        return {
          ...li,
          name: reqVar?.name,
          quantity: reqVar?.quantity,
          stockId: reqVar?.stockId ?? null,
          estimatedCost: reqVar?.cost,
          cost: reqVar?.cost,
        };
      }
      return li;
    });
    setAlternates(reqAlternates);
    setVariantValues({ ...variantValues, consumList: reqConsumList });
  };

  const onChangeConsumValue = (name, value, ind, addObj) => {
    const reqAlternates = alternates?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.nameErr = "";
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.serviceId = addObj?.serviceId;
          reqObj.category = addObj?.category;
          if (addObj?.stockId) {
            const reqBatch = addObj?.batchId
              ? getStockBatch(addObj?.stockId, addObj?.batchId)
              : stocks?.find((stc) => stc?.stockId === addObj?.stockId)
                  ?.stockBatch?.[0];
            let reqCost = 0;
            if (reqBatch && addObj?.stockId) {
              const reqQty = Number(reqObj?.quantity ?? 1);
              const uomList = getUOMListByStockId(addObj?.stockId);
              const reqUom = uomList?.[0];
              reqObj.uom = reqUom;
              const matchedUom = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqUom?.uomMappingId ||
                  matchStrIgnoreCase(ul?.value, reqUom?.name),
              );
              const batUomMatch = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqBatch?.mapId ||
                  matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
              );
              const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
              const reqPrice =
                Number(
                  Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
                ) * Number(matchedUom?.conversion ?? 1);
              reqCost = Number(reqPrice) * Number(reqQty);
            }
            reqObj.cost = reqCost;
            reqObj.batchNumber = reqBatch
              ? { name: reqBatch?.batchNo, value: reqBatch?.batchId }
              : null;
          }
          if (addObj?.serviceId) {
            const reqService = servicesList?.data?.find(
              (ser) => ser?.serviceId === addObj?.serviceId,
            );
            if (reqService) reqObj.cost = reqService?.servicePrice;
          }
        }
        if (name === "quantity") {
          reqObj.qtyErr = value?.length > 0 ? "" : "This field is required";
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === li?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, li?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (li?.serviceId) {
            reqObj.cost =
              (Number(
                servicesList?.data?.find(
                  (ser) => ser?.serviceId === li?.serviceId,
                )?.servicePrice,
              ) ?? 0) * (Number(value) ?? 1);
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "uom") {
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "batchNumber" && value?.value) {
          reqObj.batchId = value?.value;
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (li?.stockId) {
            const reqBatch = value?.value
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === value?.value)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (li?.isDefault) {
          const reqCon = getOpenedConsum();
          const reqConsumList = variantValues?.consumList?.map((li) => {
            if (li?.i === reqCon?.i) {
              return {
                ...li,
                name: reqObj?.name,
                quantity: reqObj?.quantity,
                stockId: reqObj?.stockId ?? null,
                estimatedCost: reqObj?.cost,
                cost: reqObj?.cost,
              };
            }
            return li;
          });
          setVariantValues({ ...variantValues, consumList: reqConsumList });
        }
        return reqObj;
      }
      return li;
    });
    setAlternates(reqAlternates);
  };

  const handleAddAdmin = () => {
    setAlternates([
      ...alternates,
      { ...initItem, isDefault: false, i: alternates?.length },
    ]);
  };

  const onChangeAdminDefault = (ind) => {
    const reqAdmn = getOpenedAdmin();
    const reqVar = alternates?.find((li) => li?.i === ind);
    const reqAlternates = alternates?.map((li) => ({
      ...li,
      isDefault: li?.i === ind,
    }));
    const reqAdminList = variantValues?.presList?.map((li) => {
      if (li?.i === reqAdmn?.i) {
        return {
          ...li,
          name: reqVar?.name,
          quantity: reqVar?.quantity,
          stockId: reqVar?.stockId ?? null,
          estimatedCost: reqVar?.cost,
          cost: reqVar?.cost,
          route: reqVar?.route,
          dosage: reqVar?.dosage,
        };
      }
      return li;
    });
    setAlternates(reqAlternates);
    setVariantValues({ ...variantValues, presList: reqAdminList });
  };

  const onDeleteAlterAdmin = (ind, detId = null) => {
    let reqAlternates = [];
    if (detId) {
      reqAlternates = alternates?.map((li, i) => {
        if (li?.i === ind) return { ...li, delete: false };
        return li;
      });
    } else {
      reqAlternates = alternates
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
      if (!reqAlternates?.find((li) => li?.isDefault)) {
        reqAlternates = reqAlternates?.map((li, i) => {
          if (i === 0) return { ...li, isDefault: true };
          return li;
        });
      }
    }
    setAlternates(reqAlternates);
  };

  const onChangeAdminValue = (name, value, ind, addObj) => {
    const reqAlternates = alternates?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "route") {
          reqObj.routeErr = !value ? "This field is required" : "";
        }
        if (name === "name" && addObj) {
          const reqQty = Number(reqObj?.quantity ?? 1);
          reqObj.nameErr = "";
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = stocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            )?.stockBatch?.[0];
            let reqCost = 0;
            if (reqBatch && addObj?.stockId) {
              const reqQty = Number(reqObj?.quantity ?? 1);
              const uomList = getUOMListByStockId(addObj?.stockId);
              const reqUom = uomList?.[0];
              reqObj.uom = reqUom;
              const matchedUom = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqUom?.uomMappingId ||
                  matchStrIgnoreCase(ul?.value, reqUom?.name),
              );
              const batUomMatch = uomList?.find(
                (ul) =>
                  ul?.uomMappingId === reqBatch?.mapId ||
                  matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
              );
              const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
              const reqPrice =
                Number(
                  Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
                ) * Number(matchedUom?.conversion ?? 1);
              reqCost = Number(reqPrice) * Number(reqQty);
            }
            reqObj.cost = reqCost;
            reqObj.batchNumber = reqBatch
              ? { name: reqBatch?.batchNo, value: reqBatch?.batchId }
              : null;
          }
        }
        if (name === "quantity") {
          reqObj.qtyErr = value?.length > 0 ? "" : "This field is required";
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === li?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, li?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "uom") {
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (name === "batchNumber" && value?.value) {
          reqObj.batchId = value?.value;
          const reqQty =
            Number(reqObj?.quantity ?? 0) > 0
              ? Number(reqObj?.quantity ?? 0)
              : 1;
          if (li?.stockId) {
            const reqBatch = value?.value
              ? stocks
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === value?.value)
              : stocks?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const uomList = getUOMListByStockId(reqObj?.stockId);
            const reqUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqObj?.uom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqObj?.uom?.value),
            );
            const matchedUom = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqUom?.uomMappingId ||
                matchStrIgnoreCase(ul?.value, reqUom?.name),
            );
            const batUomMatch = uomList?.find(
              (ul) =>
                ul?.uomMappingId === reqBatch?.mapId ||
                matchStrIgnoreCase(ul?.value, reqBatch?.uomMapName),
            );
            const stckUnitPrice = reqBatch?.unitSellingPrice ?? 0;
            const reqPrice =
              Number(
                Number(stckUnitPrice) / Number(batUomMatch?.conversion ?? 1),
              ) * Number(matchedUom?.conversion ?? 1);
            const reqCost = (Number(reqPrice) ?? 0) * (Number(reqQty) ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        // if (name === "dosage") {
        //   reqObj.dosErr =
        //     value?.length > 0
        //       ? Number(value) > 0
        //         ? ""
        //         : "Value must be positive"
        //       : "This field is reqired";
        //   if (li?.stockId) {
        //     const reqBatch = stocks?.find((stc) => stc?.stockId === li?.stockId)
        //       ?.stockBatch?.[0];
        //     const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
        //     const priceRatio = Number(value) / Number(reqPack?.[1]);
        //     const reqPrice =
        //       (Number(reqBatch?.unitSellingPrice) ?? 0) *
        //       Number(priceRatio ?? 0);
        //     reqObj.cost = reqPrice;
        //   }
        // }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        if (li?.isDefault) {
          const reqAdmn = getOpenedAdmin();
          const reqAdminList = variantValues?.presList?.map((li) => {
            if (li?.i === reqAdmn?.i) {
              return {
                ...li,
                name: reqObj?.name,
                quantity: reqObj?.quantity,
                stockId: reqObj?.stockId ?? null,
                estimatedCost: reqObj?.cost,
                cost: reqObj?.cost,
                route: reqObj?.route,
                dosage: reqObj?.dosage,
              };
            }
            return li;
          });
          setVariantValues({ ...variantValues, presList: reqAdminList });
        }
        return reqObj;
      }
      return li;
    });
    setAlternates(reqAlternates);
  };

  const getModalList = (value = false) => {
    const list = getList(value);
    if (alternates?.length === 0 || !alternates) return list;
    const stockIdsToExclude = new Set(alternates?.map((item) => item?.stockId));
    const reqList = list?.filter(
      (item) => !stockIdsToExclude?.has(item?.stockId),
    );
    return reqList;
  };

  const handleAddConsum = () => {
    setAlternates([
      ...alternates,
      { ...initItem, isDefault: false, i: alternates?.length },
    ]);
  };

  const onDeleteAlterConsum = (ind, detId = null) => {
    let reqAlternates = [];
    if (detId) {
      reqAlternates = alternates?.map((li, i) => {
        if (li?.i === ind) return { ...li, delete: true };
        return li;
      });
    } else {
      reqAlternates = alternates
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
      if (!reqAlternates?.find((li) => li?.isDefault)) {
        reqAlternates = reqAlternates?.map((li, i) => {
          if (i === 0) return { ...li, isDefault: true };
          return li;
        });
      }
    }
    setAlternates(reqAlternates);
  };

  const handleConsumOpen = () => {
    setConsumOpen(!consumOpen);
  };

  const handleAdminOpen = () => {
    setAdminOpen(!adminOpen);
  };

  const getBatch = (stockId, batchId = null, retStock = false) => {
    if (!stockId) return null;
    const reqStock = stocks?.find((stc) => stc?.stockId === stockId);
    if (retStock) return reqStock;
    if (!batchId) return null;
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getBatches = (stkId = null) => {
    const reqStock = stocks?.find((stc) => stc?.stockId === stkId);

    return reqStock?.stockBatch?.length > 0
      ? reqStock?.stockBatch?.map((bat) => {
          const reqLocation = locations?.find(
            (loc) => loc?.id === bat?.locationId,
          );
          return {
            name: bat?.batchNo,
            value: bat?.batchId,
            subunits: bat?.subunits,
            quantity: bat?.quantity,
            locationId: bat?.locationId,
            locationName: reqLocation?.locationName ?? "",
          };
        })
      : [
          {
            name: "Unknown",
            value: null,
            subunits: null,
            quantity: null,
            locationId: null,
            locationName: "",
          },
        ];
  };

  const getStockById = (stkId) => {
    return stocks?.find((stc) => stc?.stockId === stkId) ?? null;
  };

  const getUOMListByStockId = (stkId = null) => {
    if (!stkId) return [];
    const stockMat = getStockById(stkId);
    if (!stockMat) return [];
    const reqList = stockMat?.uomMappings
      ?.filter((ml) => ml?.allowSale === "Y" && ml?.show)
      ?.map((ml) => ({
        name: (ml?.unit ?? "")?.trim()?.toUpperCase(),
        value: (ml?.unit ?? "")?.trim()?.toUpperCase(),
        conversion: ml?.conversion,
        uomMappingId: ml?.uomMappingId ?? null,
      }));
    return reqList;
  };

  const getDevices = () => {
    const reqList = (facilities ?? [])
      ?.filter((fac) => (fac?.type ?? "")?.toLowerCase() === "devices")
      ?.map((fac) => ({ name: fac?.name, value: fac?.name }));
    return reqList;
  };

  return (
    <>
      <CustomModal
        open={modVsble}
        onClose={() => handleClose("close")}
        header={selectedService?.serviceId ? "Edit" : "Create"}
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <Typography className="font-bold fs16 blue-color">
                  Service Details
                </Typography>
                <div className="flex1-end">
                  <div>
                    <Typography className="gray-color fs12 font-medium">
                      Created Date:{" "}
                      {moment(
                        new Date(selectedService?.createdDate ?? new Date()),
                      ).format("DD MMM YYYY, HH:mm")}
                    </Typography>
                    <Typography className="gray-color fs12 font-medium">
                      Updated Date:{" "}
                      {moment(
                        new Date(
                          selectedService?.updatedDate ??
                            selectedService?.createdDate ??
                            new Date(),
                        ),
                      ).format("DD MMM YYYY, HH:mm")}
                    </Typography>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label={hl("Disabled", "active")}
                checked={serviceValues?.active}
                onChange={() => handleChange("active", !serviceValues?.active)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              {/* <div className="txt-semi-bold fs14 light-grey">
                    Type <span className="red-color">*</span>
                  </div> */}
              <div className="mb20">
                <Select
                  list={ServiceTypes}
                  value={serviceValues?.type}
                  handleChange={(e) => handleChange("type", e?.target?.value)}
                  name="type"
                  select
                  error={serviceErrors?.type}
                  helperText={serviceHelps?.type}
                  label={hl("Type *", "type")}
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              {/* <div className="txt-semi-bold fs14 light-grey">
                    Category <span className="red-color">*</span>
                  </div> */}
              <div className="mb20">
                <Select
                  list={getServiceCategories()}
                  value={serviceValues?.category}
                  handleChange={(e, value) => {
                    handleChange("category", value);
                  }}
                  name="category"
                  search
                  error={serviceErrors?.category}
                  helperText={serviceHelps?.category}
                  label={hl("Category *", "category")}
                />
              </div>
            </Grid>
            {serviceValues?.category?.value !== "Radiology" ? (
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">
                    Subcategory <span className="red-color">*</span>
                  </div> */}
                <div className="mb20">
                  <Select
                    list={subCategoryList}
                    value={serviceValues?.subCategory}
                    handleChange={(e, value) => {
                      handleChange("subCategory", value);
                    }}
                    name="subCategory"
                    search
                    error={serviceErrors?.subCategory}
                    helperText={serviceHelps?.subCategory}
                    label={hl("Subcategory *", "subCategory")}
                  />
                </div>
              </Grid>
            ) : null}
            {serviceValues?.category?.value === "Radiology" ? (
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <div className="mb20">
                  <Select
                    list={modalities}
                    value={serviceValues?.modality}
                    handleChange={(e) =>
                      handleChange("modality", e?.target?.value)
                    }
                    name="modality"
                    select
                    error={serviceErrors?.modality}
                    helperText={serviceHelps?.modality}
                    label={hl("Modality *", "modality")}
                  />
                </div>
              </Grid>
            ) : null}
            <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              <div className="mb20">
                <CustomTextField
                  name="serviceName"
                  fullWidth
                  helperText={serviceHelps?.serviceName}
                  error={serviceErrors?.serviceName}
                  value={serviceValues?.serviceName}
                  handleChange={(e) =>
                    handleChange("serviceName", e?.target?.value)
                  }
                  label={hl("Procedure Name", "serviceName")}
                  required={true}
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              {/* <div className="txt-semi-bold fs14 light-grey">SAC Code</div> */}
              <div className="mb20">
                <CustomTextField
                  name="hsnSacCode"
                  fullWidth
                  helperText={serviceHelps?.hsnSacCode}
                  error={serviceErrors?.hsnSacCode}
                  value={serviceValues?.hsnSacCode}
                  handleChange={(e) =>
                    handleChange("hsnSacCode", e?.target?.value)
                  }
                  label={hl("SAC Code", "hsnSacCode")}
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              {/* <div className="txt-semi-bold fs14 light-grey">Tax Applicability</div> */}
              <div className="mb20">
                <Select
                  list={yesNoValueList}
                  value={serviceValues?.taxApplicability}
                  handleChange={(e) =>
                    handleChange("taxApplicability", e?.target?.value)
                  }
                  name="taxApplicability"
                  select
                  error={serviceErrors?.taxApplicability}
                  helperText={serviceHelps?.taxApplicability}
                  label={hl("Tax Applicability *", "taxApplicability")}
                />
              </div>
            </Grid>
            {serviceValues?.taxApplicability?.toLowerCase() === "yes" ? (
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">Tax %</div> */}
                <div className="mb20">
                  <CustomTextField
                    name="tax"
                    fullWidth
                    helperText={serviceHelps?.tax}
                    error={serviceErrors?.tax}
                    value={serviceValues?.tax}
                    handleChange={(e) => handleChange("tax", e?.target?.value)}
                    label={hl("Tax % *", "tax")}
                    type="number"
                  />
                </div>
              </Grid>
            ) : null}
            {serviceValues?.category?.value === "Lab" ||
            serviceValues?.category?.value === "Radiology" ? (
              <>
                {serviceValues?.category?.value === "Lab" && (
                  <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                    <div className="mb20">
                      <Select
                        list={sampleTypes}
                        value={serviceValues?.sampleType}
                        handleChange={(e) =>
                          handleChange("sampleType", e?.target?.value)
                        }
                        name="sampleType"
                        select
                        error={serviceErrors?.sampleType}
                        helperText={serviceHelps?.sampleType}
                        label={hl("Sample Type", "sampleType")}
                      />
                    </div>
                  </Grid>
                )}
                {serviceValues?.category?.value === "Radiology" && (
                  <>
                    {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <div className="mb20">
                            <Select
                              list={modalities}
                              value={serviceValues?.modality}
                              handleChange={(e) =>
                                handleChange("modality", e?.target?.value)
                              }
                              name="modality"
                              select
                              error={serviceErrors?.modality}
                              helperText={serviceHelps?.modality}
                              label={hl("Modality *", "modality")}
                            />
                          </div>
                        </Grid> */}
                    {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <div className="mb20">
                            <Select
                              list={getRegionListBasedOnModality(
                                serviceValues?.modality?.length > 0
                                  ? serviceValues?.modality
                                  : null
                              )}
                              value={serviceValues?.region}
                              handleChange={(e) => handleChange("region", e)}
                              name="region"
                              reason
                              error={serviceErrors?.region}
                              helperText={serviceHelps?.region}
                              label={hl("Region *", "region")}
                            />
                          </div>
                        </Grid> */}
                    {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                          <div className="mb20">
                            <Select
                              list={devices}
                              value={serviceValues?.device}
                              handleChange={(e) =>
                                handleChange("device", e?.target?.value)
                              }
                              name="device"
                              select
                              error={serviceErrors?.device}
                              helperText={serviceHelps?.device}
                              label={hl("Device", "device")}
                            />
                          </div>
                        </Grid> */}
                  </>
                )}

                {/* Diagnostic Template select hidden — use Reminder-style card below */}
                {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                  <div className="mb20">
                    <Select
                      list={getDiagnosticTemplateList()}
                      value={serviceValues?.diagnosticTemplate}
                      handleChange={(e, value) => {
                        handleChange("diagnosticTemplate", value);
                      }}
                      name="diagnosticTemplate"
                      search
                      error={serviceErrors?.diagnosticTemplate}
                      helperText={serviceHelps?.diagnosticTemplate}
                      label={hl("Diagnostic Template", "diagnosticTemplate")}
                    />
                  </div>
                </Grid> */}
                {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                      <div className="mb20">
                        <Select
                          list={doneAtList}
                          value={serviceValues?.doneAt}
                          handleChange={(e) =>
                            handleChange("doneAt", e?.target?.value)
                          }
                          name="doneAt"
                          select
                          error={serviceErrors?.doneAt}
                          helperText={serviceHelps?.doneAt}
                          label={hl("Done At", "doneAt")}
                        />
                      </div>
                    </Grid> */}
                {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                      <div className="mb20">
                        <CustomTextField
                          name="processingTime"
                          fullWidth
                          helperText={serviceHelps?.processingTime}
                          error={serviceErrors?.processingTime}
                          value={serviceValues?.processingTime}
                          handleChange={(e) =>
                            handleChange("processingTime", e?.target?.value)
                          }
                          label={hl("Processing Time", "estimatedDuration")}
                        />
                      </div>
                    </Grid> */}
              </>
            ) : null}
            {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
              <div className="flex-row mb20">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="nextDueValue"
                    label={hl("Next Due", "nextDue")}
                    fullWidth
                    value={serviceValues?.nextDueValue}
                    handleChange={(e) =>
                      handleChange("nextDueValue", e?.target?.value)
                    }
                    type="number"
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={nextDueTypes}
                    value={serviceValues?.nextDueType}
                    handleChange={(e) =>
                      handleChange("nextDueType", e?.target?.value)
                    }
                    name="dosageType"
                    select
                    label={hl("Unit", "nextDueType")}
                  />
                </div>
              </div>
            </Grid> */}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container spacing={2} alignItems="stretch">
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Box
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      backgroundColor: "#ffffff",
                      p: 2.5,
                      height: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "16px",
                        color: AppColors.appPrimary,
                      }}
                    >
                      Reminder Template
                    </Typography>
                    {linkedRemainderTemplates?.length > 0 ? (
                      <Box display="flex" flexDirection="column" gap={1.25}>
                        {linkedRemainderTemplates.map((tmp) => (
                          <Box
                            key={getRemainderId(tmp) ?? tmp?.templateName}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              border: "1px solid #e6eaf0",
                              borderRadius: "10px",
                              px: 1.5,
                              py: 1.25,
                              backgroundColor: "#fff",
                            }}
                          >
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                minWidth: 36,
                                borderRadius: "8px",
                                backgroundColor: "#F3EEFF",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <AlarmIcon
                                sx={{ fontSize: 20, color: "#E53935" }}
                              />
                            </Box>
                            <Box flex={1} minWidth={0}>
                              <Typography
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "15px",
                                  color: AppColors.appPrimary,
                                  lineHeight: 1.3,
                                }}
                              >
                                {tmp?.templateName ?? tmp?.name ?? "Untitled"}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "#8a93a3",
                                  mt: 0.25,
                                }}
                              >
                                {getTemplateStepSummary(tmp)}
                              </Typography>
                            </Box>
                            <Box
                              className="cursor"
                              display="flex"
                              alignItems="center"
                              onClick={() => handleEditRemainder(tmp)}
                              sx={{
                                color: AppColors.appPrimary,
                                flexShrink: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: AppColors.appPrimary,
                                }}
                              >
                                View / Edit
                              </Typography>
                              <ArrowForwardIcon
                                sx={{ fontSize: 16, ml: 0.5 }}
                              />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box
                        className="cursor"
                        onClick={handleOpenAddRemainder}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          border: "1px dashed #cfd8e3",
                          borderRadius: "10px",
                          px: 1.5,
                          py: 1.5,
                          backgroundColor: "#fafcfe",
                        }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            minWidth: 36,
                            borderRadius: "8px",
                            backgroundColor: "#F3EEFF",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <AddIcon
                            sx={{ fontSize: 20, color: AppColors.appPrimary }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "14px",
                              color: AppColors.appPrimary,
                            }}
                          >
                            Add
                          </Typography>
                          <Typography
                            sx={{ fontSize: "12px", color: "#8a93a3" }}
                          >
                            Link a reminder template to this service
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>

                {(serviceValues?.category?.value === "Lab" ||
                  serviceValues?.category?.value === "Radiology") && (
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        p: 2.5,
                        height: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: "16px",
                          color: AppColors.appPrimary,
                        }}
                      >
                        Diagnostic Template
                      </Typography>
                      {linkedDiagnosticTemplates?.length > 0 ? (
                        <Box display="flex" flexDirection="column" gap={1.25}>
                          {linkedDiagnosticTemplates.map((tmp) => (
                            <Box
                              key={
                                getDiagnosticTemplateId(tmp) ??
                                tmp?.templateName
                              }
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                border: "1px solid #e6eaf0",
                                borderRadius: "10px",
                                px: 1.5,
                                py: 1.25,
                                backgroundColor: "#fff",
                              }}
                            >
                              <Box
                                sx={{
                                  width: 36,
                                  height: 36,
                                  minWidth: 36,
                                  borderRadius: "8px",
                                  backgroundColor: "#E8F5E9",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <DescriptionOutlinedIcon
                                  sx={{ fontSize: 20, color: "#2E7D32" }}
                                />
                              </Box>
                              <Box flex={1} minWidth={0}>
                                <Typography
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: "15px",
                                    color: AppColors.appPrimary,
                                    lineHeight: 1.3,
                                  }}
                                >
                                  {tmp?.templateName ?? tmp?.name ?? "Untitled"}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#8a93a3",
                                    mt: 0.25,
                                  }}
                                >
                                  {getDiagnosticTemplateSummary(tmp)}
                                </Typography>
                              </Box>
                              <Box
                                className="cursor"
                                display="flex"
                                alignItems="center"
                                onClick={() =>
                                  handleEditDiagnosticTemplate(tmp)
                                }
                                sx={{
                                  color: AppColors.appPrimary,
                                  flexShrink: 0,
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: AppColors.appPrimary,
                                  }}
                                >
                                  View / Edit
                                </Typography>
                                <ArrowForwardIcon
                                  sx={{ fontSize: 16, ml: 0.5 }}
                                />
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ) : (
                        <Box
                          className="cursor"
                          onClick={handleOpenAddDiagnosticTemplate}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            border: "1px dashed #cfd8e3",
                            borderRadius: "10px",
                            px: 1.5,
                            py: 1.5,
                            backgroundColor: "#fafcfe",
                          }}
                        >
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              minWidth: 36,
                              borderRadius: "8px",
                              backgroundColor: "#E8F5E9",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <AddIcon
                              sx={{
                                fontSize: 20,
                                color: AppColors.appPrimary,
                              }}
                            />
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                color: AppColors.appPrimary,
                              }}
                            >
                              Add
                            </Typography>
                            <Typography
                              sx={{ fontSize: "12px", color: "#8a93a3" }}
                            >
                              Link a diagnostic template to this service
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2} alignItems="stretch" sx={{ mt: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Box
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      backgroundColor: "#ffffff",
                      p: 2.5,
                      height: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "16px",
                        color: AppColors.appPrimary,
                        mb: 1.5,
                      }}
                    >
                      Consent Form
                    </Typography>
                    {linkedConsentForms?.length > 0 ? (
                      <Box display="flex" flexDirection="column" gap={1.25}>
                        {linkedConsentForms.map((frm) => (
                          <Box
                            key={getFormId(frm) ?? frm?.name}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              border: "1px solid #e6eaf0",
                              borderRadius: "10px",
                              px: 1.5,
                              py: 1.25,
                              backgroundColor: "#fff",
                            }}
                          >
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                minWidth: 36,
                                borderRadius: "8px",
                                backgroundColor: "#FFF3E0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <AssignmentOutlinedIcon
                                sx={{ fontSize: 20, color: "#EF6C00" }}
                              />
                            </Box>
                            <Box flex={1} minWidth={0}>
                              <Typography
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "15px",
                                  color: AppColors.appPrimary,
                                  lineHeight: 1.3,
                                }}
                              >
                                {frm?.name ?? "Untitled"}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "#8a93a3",
                                  mt: 0.25,
                                }}
                              >
                                {getFormSummary(frm)}
                              </Typography>
                            </Box>
                            <Box
                              className="cursor"
                              display="flex"
                              alignItems="center"
                              onClick={() => handleEditForm(frm)}
                              sx={{
                                color: AppColors.appPrimary,
                                flexShrink: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: AppColors.appPrimary,
                                }}
                              >
                                View / Edit
                              </Typography>
                              <ArrowForwardIcon
                                sx={{ fontSize: 16, ml: 0.5 }}
                              />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box
                        className="cursor"
                        onClick={handleOpenAddForm}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          border: "1px dashed #cfd8e3",
                          borderRadius: "10px",
                          px: 1.5,
                          py: 1.5,
                          backgroundColor: "#fafcfe",
                        }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            minWidth: 36,
                            borderRadius: "8px",
                            backgroundColor: "#FFF3E0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <AddIcon
                            sx={{ fontSize: 20, color: AppColors.appPrimary }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "14px",
                              color: AppColors.appPrimary,
                            }}
                          >
                            Add
                          </Typography>
                          <Typography
                            sx={{ fontSize: "12px", color: "#8a93a3" }}
                          >
                            Link a consent form to this service
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Box
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      backgroundColor: "#ffffff",
                      p: 2.5,
                      height: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "16px",
                        color: AppColors.appPrimary,
                        mb: 1.5,
                      }}
                    >
                      Certificate
                    </Typography>
                    {linkedCertificates?.length > 0 ? (
                      <Box display="flex" flexDirection="column" gap={1.25}>
                        {linkedCertificates.map((cert) => (
                          <Box
                            key={getCertificateId(cert) ?? cert?.name}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              border: "1px solid #e6eaf0",
                              borderRadius: "10px",
                              px: 1.5,
                              py: 1.25,
                              backgroundColor: "#fff",
                            }}
                          >
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                minWidth: 36,
                                borderRadius: "8px",
                                backgroundColor: "#E3F2FD",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <WorkspacePremiumOutlinedIcon
                                sx={{ fontSize: 20, color: "#1565C0" }}
                              />
                            </Box>
                            <Box flex={1} minWidth={0}>
                              <Typography
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "15px",
                                  color: AppColors.appPrimary,
                                  lineHeight: 1.3,
                                }}
                              >
                                {cert?.name ?? "Untitled"}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  color: "#8a93a3",
                                  mt: 0.25,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {getCertificateSummary(cert)}
                              </Typography>
                            </Box>
                            <Box
                              className="cursor"
                              display="flex"
                              alignItems="center"
                              onClick={() => handleEditCertificate(cert)}
                              sx={{
                                color: AppColors.appPrimary,
                                flexShrink: 0,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: AppColors.appPrimary,
                                }}
                              >
                                View / Edit
                              </Typography>
                              <ArrowForwardIcon
                                sx={{ fontSize: 16, ml: 0.5 }}
                              />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Box
                        className="cursor"
                        onClick={handleOpenAddCertificate}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          border: "1px dashed #cfd8e3",
                          borderRadius: "10px",
                          px: 1.5,
                          py: 1.5,
                          backgroundColor: "#fafcfe",
                        }}
                      >
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            minWidth: 36,
                            borderRadius: "8px",
                            backgroundColor: "#E3F2FD",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <AddIcon
                            sx={{ fontSize: 20, color: AppColors.appPrimary }}
                          />
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "14px",
                              color: AppColors.appPrimary,
                            }}
                          >
                            Add
                          </Typography>
                          <Typography
                            sx={{ fontSize: "12px", color: "#8a93a3" }}
                          >
                            Link a certificate to this service
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  backgroundColor: "#ffffff",
                  p: 2.5,
                  mb: 2,
                }}
              >
                <Box display="flex" alignItems="center" gap={0.5} mb={0.75}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "16px",
                      color: AppColors.appPrimary,
                    }}
                  >
                    Linked Subcategories — quick-search scope
                  </Typography>
                  <FieldInfoIcon
                    text={SERVICE_FIELD_HELP.linkedSubcategories}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "13px",
                    color: "#757575",
                    lineHeight: 1.5,
                    mb: 1.5,
                  }}
                >
                  The broadest tier — stock items in these subcategories become
                  searchable for every variant of this service.
                </Typography>
                <CustomSelect
                  list={allLinkedSubCategoryOptions}
                  name="linkedSubcategories"
                  handleChange={handleLinkedSubCategoryChange}
                  value={serviceValues?.linkedSubcategories ?? []}
                  multiSelectSearchCheck
                />
                {(serviceValues?.linkedSubcategories ?? [])?.length > 0 ? (
                  <Box
                    display="flex"
                    alignItems="center"
                    flexWrap="wrap"
                    gap={1}
                    mt={1.5}
                  >
                    {(serviceValues?.linkedSubcategories ?? [])?.map((sc) => (
                      <Box
                        key={sc?.value}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 0.75,
                          backgroundColor: "#e8f4fd",
                          color: AppColors.appPrimary,
                          borderRadius: "999px",
                          px: 1.5,
                          py: 0.6,
                          fontSize: "13px",
                          fontWeight: 600,
                        }}
                      >
                        {sc?.name}
                        <CloseIcon
                          sx={{
                            fontSize: 16,
                            cursor: "pointer",
                            opacity: 0.75,
                            "&:hover": { opacity: 1 },
                          }}
                          onClick={() => removeLinkedSubCategory(sc?.value)}
                        />
                      </Box>
                    ))}
                  </Box>
                ) : null}
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs16 blue-color">
                  Variants
                </Typography>
                <FieldInfoIcon text={SERVICE_FIELD_HELP.variants} />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card sx={cardSty}>
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <div
                    style={{
                      minWidth:
                        1390 +
                        (serviceValues?.category?.value === "Radiology"
                          ? 600
                          : serviceValues?.category?.value === "Lab"
                            ? 400
                            : 0),
                    }}
                  >
                    <div className="flex-row mh10">
                      <div style={{ width: 150 }}>
                        <ColHelp helpKey="variantId">Variant Id</ColHelp>
                      </div>
                      <div style={{ width: 300 }}>
                        <ColHelp helpKey="variantName">
                          Variant Name <span className="red-color">*</span>
                        </ColHelp>
                      </div>
                      <div style={{ width: 150 }}>
                        <ColHelp helpKey="bomCharge">BOM Charge</ColHelp>
                      </div>
                      <div style={{ width: 250 }}>
                        <ColHelp helpKey="estimatedDuration">
                          Estimated Duration (In Minutes){" "}
                          {checkEstDurationIsMandatory() ? (
                            <span className="red-color">*</span>
                          ) : null}
                        </ColHelp>
                      </div>
                      <div style={{ width: 200 }}>
                        <ColHelp helpKey="serviceCharge">
                          Service Charge <span className="red-color">*</span>
                        </ColHelp>
                      </div>
                      <div style={{ width: 200 }}>
                        <ColHelp helpKey="bundledSellingPrice">
                          Package Price <span className="red-color">*</span>
                        </ColHelp>
                      </div>
                      {serviceValues?.category?.value === "Radiology" && (
                        <div style={{ width: 200 }}>
                          <ColHelp helpKey="region">
                            Region <span className="red-color">*</span>
                          </ColHelp>
                        </div>
                      )}
                      {(serviceValues?.category?.value === "Radiology" ||
                        serviceValues?.category?.value === "Lab") && (
                        <>
                          <div style={{ width: 200 }}>
                            <ColHelp helpKey="device">Device</ColHelp>
                          </div>
                          <div style={{ width: 200 }}>
                            <ColHelp helpKey="doneAt">Done At</ColHelp>
                          </div>
                        </>
                      )}
                      <div style={{ width: 70 }} />
                      <div style={{ width: 70 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {serviceValues?.variants
                      ?.filter(
                        (li) =>
                          !li?.delete &&
                          (li?.createdBy ? li?.createdBy === clinic?.id : true),
                      )
                      ?.map((li, ind) => (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={li?.i + "var"}
                        >
                          <div style={{ width: 150 }} className="pr10">
                            <CustomTextField
                              fullWidth
                              value={li?.variantNumber}
                              handleChange={(e) =>
                                onChangeVarValue(
                                  "variantNumber",
                                  e?.target?.value,
                                  li?.i,
                                )
                              }
                            />
                          </div>
                          <div className="pr10" style={{ width: 300 }}>
                            <CustomTextField
                              fullWidth
                              value={li?.variantName}
                              error={!!li?.nameErr}
                              helperText={li?.nameErr}
                              handleChange={(e) =>
                                onChangeVarValue(
                                  "variantName",
                                  e?.target?.value,
                                  li?.i,
                                )
                              }
                            />
                          </div>
                          <div style={{ width: 150 }}>
                            <Typography className="font-medium fs14 mt10">
                              Rs.{" "}
                              {Number(
                                getTotalEstimatedCost([
                                  ...(li?.consumList ?? []),
                                  ...(li?.presList ?? []),
                                ]),
                              )?.toFixed(2)}
                            </Typography>
                          </div>
                          <div className="pr10" style={{ width: 250 }}>
                            <CustomTextField
                              fullWidth
                              value={li?.estimatedDuration}
                              error={!!li?.durError}
                              helperText={li?.durError}
                              handleChange={(e) =>
                                onChangeVarValue(
                                  "estimatedDuration",
                                  e?.target?.value,
                                  li?.i,
                                )
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomTextField
                              fullWidth
                              value={li?.serviceCharge}
                              error={!!li?.chargeErr}
                              helperText={li?.chargeErr}
                              handleChange={(e) =>
                                onChangeVarValue(
                                  "serviceCharge",
                                  e?.target?.value,
                                  li?.i,
                                )
                              }
                              type="number"
                            />
                          </div>
                          <div className="pr10" style={{ width: 200 }}>
                            <CustomTextField
                              fullWidth
                              value={li?.servicePrice}
                              error={!!li?.serPriceErr}
                              helperText={li?.serPriceErr}
                              handleChange={(e) =>
                                onChangeVarValue(
                                  "servicePrice",
                                  e?.target?.value,
                                  li?.i,
                                )
                              }
                              type="number"
                            />
                          </div>
                          {serviceValues?.category?.value === "Radiology" && (
                            <div className="pr10" style={{ width: 200 }}>
                              <Select
                                list={getRegionListBasedOnModality(
                                  serviceValues?.modality,
                                )}
                                value={li?.region}
                                handleChange={(e) =>
                                  onChangeVarValue("region", e, li?.i)
                                }
                                reason
                                error={!!li?.regionErr}
                                helperText={li?.regionErr}
                              />
                            </div>
                          )}
                          {(serviceValues?.category?.value === "Radiology" ||
                            serviceValues?.category?.value === "Lab") && (
                            <>
                              <div className="pr10" style={{ width: 200 }}>
                                <Select
                                  list={getDevices()}
                                  value={li?.device}
                                  handleChange={(e) =>
                                    onChangeVarValue(
                                      "device",
                                      e?.target?.value,
                                      li?.i,
                                    )
                                  }
                                  name="device"
                                  select
                                />
                              </div>
                              <div className="pr10" style={{ width: 200 }}>
                                <Select
                                  list={doneAtList}
                                  value={li?.doneAt}
                                  handleChange={(e) =>
                                    onChangeVarValue(
                                      "doneAt",
                                      e?.target?.value,
                                      li?.i,
                                    )
                                  }
                                  name="doneAt"
                                  select
                                />
                              </div>
                            </>
                          )}
                          <div style={{ width: 70 }} className="mt5">
                            <div
                              className="cursor"
                              onClick={() => handleView(li)}
                            >
                              <div className="flex-center">
                                <VisibilityIcon sx={plusBtn} />
                              </div>
                              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                View
                              </Typography>
                            </div>
                          </div>
                          <div style={{ width: 70 }} className="mt5">
                            {ind !== 0 ? (
                              <div
                                className="cursor"
                                onClick={() => handleDeleteVariant(li?.i)}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ))}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={addVariant}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {/* <div className="txt-semi-bold fs14 light-grey">Remarks</div> */}
              <CustomTextField
                name="description"
                label={hl("Remarks", "description")}
                fullWidth
                value={serviceValues?.description}
                error={serviceErrors?.description}
                helperText={serviceHelps?.description}
                handleChange={(e) =>
                  handleChange("description", e?.target?.value)
                }
                multiline
              />
            </Grid>
          </Grid>

          <div className="mt30 mb20">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <div className="flex1-end">
                  <div className="flex-row-ali-cen">
                    <div className="mr10">
                      <CustomButton
                        text="Cancel"
                        textBtn
                        onClick={() => handleClose("close")}
                        color={AppColors.red}
                      />
                    </div>
                    <div className="ml10">
                      <CustomButton
                        text="Submit"
                        onClick={handleSubmit}
                        smallBtn
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={slctedVariant}
        onClose={handleVariantClose}
        header="Variant"
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh ph20">
          <div className="flex-row-between-align-center">
            <div>
              <div className="report-selctd-bodr br10 ph15 pv10">
                <Typography className="font-bold fs16 blue-color">
                  Variant Name: {slctedVariant?.variantName}
                </Typography>
                <Typography className="light-blue fs14 txt-semi-bold">
                  Variant Id: {slctedVariant?.variantNumber}
                </Typography>
                <Typography className="red-color fs14 txt-semi-bold">
                  Service Charge : Rs.{" "}
                  {Number(slctedVariant?.serviceCharge ?? 0)?.toFixed(2)}
                </Typography>
              </div>
            </div>
          </div>
          <div className="green-back4 ph20 pv10 br10 mt20">
            <div className="flex-row-between-align-center">
              <Typography className="txt-semi-bold fs14 orange5">
                BOM Charge:
              </Typography>
              <Typography className="font-bold fs14 orange5 ml10">
                Rs{" "}
                {Number(
                  getTotalEstimatedCost([
                    ...(variantValues?.consumList ?? []),
                    ...(variantValues?.presList ?? []),
                  ]),
                )?.toFixed(2)}
              </Typography>
            </div>
          </div>
          <div className="mt20">
            <Card sx={cardSty}>
              <div className="flex-row-ali-cen">
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Consumables
                  </Typography>
                  <FieldInfoIcon text={SERVICE_FIELD_HELP.consumables} />
                </div>
              </div>
              <div className="flex-column mt10">
                <div className="flex-row-ali-cen mh10">
                  <div className="w30Per">
                    <ColHelp helpKey="itemName">
                      Name <span className="red-color">*</span>
                    </ColHelp>
                  </div>
                  {/* <div className="w20Per">
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Batch Number
                    </Typography>
                  </div> */}
                  <div className="w20Per">
                    <ColHelp helpKey="billableQty">
                      Billable Qty <span className="red-color">*</span>
                    </ColHelp>
                  </div>
                  <div className="w20Per">
                    <ColHelp helpKey="uom">UOM</ColHelp>
                  </div>
                  <div className="w20Per">
                    <ColHelp helpKey="bomCharge">BOM Charge</ColHelp>
                  </div>
                  <div className="w10Per" />
                </div>
                <div className="blue-hor-split mt5" />
                {variantValues?.consumList
                  ?.filter((li) => !li?.delete)
                  ?.map((li, i) => {
                    return (
                      <div
                        className="flex-row mt10 plan-bor"
                        key={i + "consum"}
                      >
                        <div className="w30Per pr10">
                          <CustomSelect
                            list={getList(false)}
                            value={li?.name}
                            addNewSelect
                            searchOnly
                            mandatoryField
                            error={!!li?.nameErr}
                            helperText={li?.nameErr}
                            handleChange={(e) => {
                              handleConsumChange("name", e?.value ?? e, i, {
                                stockId: e?.stockId ?? null,
                                batchId: e?.batchId ?? null,
                                serviceId: e?.serviceId ?? null,
                                category: e?.category ?? null,
                              });
                            }}
                          />
                        </div>
                        {/* <div className="w20Per pr10">
                          <CustomSelect
                            list={getBatches(li?.stockId)}
                            value={li?.batchNumber}
                            handleChange={(e, value) => {
                              handleConsumChange("batchNumber", value, i);
                            }}
                            name="batchNumber"
                            search
                            isBatchNumber
                          />
                        </div> */}
                        <div className="w20Per pr10">
                          <CustomTextField
                            value={li?.quantity}
                            error={!!li?.qtyErr}
                            helperText={li?.qtyErr}
                            handleChange={(e) =>
                              handleConsumChange(
                                "quantity",
                                e?.target?.value,
                                i,
                              )
                            }
                            fullWidth
                            type="number"
                          />
                        </div>
                        <div className="w20Per pr10">
                          <CustomSelect
                            list={getUOMListByStockId(li?.stockId)}
                            value={li?.uom}
                            search
                            handleChange={(e, value) => {
                              handleConsumChange("uom", value, i);
                            }}
                          />
                        </div>
                        <div className="w20Per pr10 mt10">
                          <Typography className="txt-regular fs12 gray20 ml5">
                            {Number(li?.cost) > 0
                              ? `Rs ${Number(li?.cost)?.toFixed(2)}`
                              : "-"}
                          </Typography>
                        </div>
                        <div className="w10Per flex-end">
                          <div
                            className="cursor"
                            onClick={() => handleConsumAlternates(li?.i, true)}
                          >
                            <div className="flex-center">
                              <AddIcon sx={plusBtn} />
                            </div>
                            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                              Alternates
                            </Typography>
                          </div>
                          <div
                            className="cursor pr10 ml10"
                            onClick={() =>
                              handleConsumDelete(i, li?.detailId ?? null)
                            }
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                <div
                  className="flex-row-ali-cen mt10 cursor"
                  onClick={() => handleAddTask("consum")}
                >
                  <div className="flex-center plus-icon">
                    <AddIcon sx={plusBtn} />
                  </div>
                  <Typography className="blue-color fs16 ml5 font-bold">
                    Add
                  </Typography>
                </div>
              </div>
            </Card>
          </div>
          <div className="mt20">
            <Card sx={cardSty}>
              <div className="flex-row-ali-cen">
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Administered
                  </Typography>
                  <FieldInfoIcon text={SERVICE_FIELD_HELP.administered} />
                </div>
              </div>

              <div style={{ overflowX: "auto", width: "100%" }}>
                <div style={{ minWidth: 1120 }}>
                  <div className="flex-column mt10">
                    <div className="flex-row-ali-cen mh10">
                      <div style={{ width: 250 }}>
                        <ColHelp helpKey="itemName">
                          Name <span className="red-color">*</span>
                        </ColHelp>
                      </div>
                      {/* <div style={{ width: 220 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Batch Number
                        </Typography>
                      </div> */}
                      <div style={{ width: 150 }}>
                        <ColHelp helpKey="billableQty">
                          Billable Qty <span className="red-color">*</span>
                        </ColHelp>
                      </div>
                      <div style={{ width: 170 }}>
                        <ColHelp helpKey="uom">UOM</ColHelp>
                      </div>
                      <div style={{ width: 150 }}>
                        <ColHelp helpKey="dose">Dose</ColHelp>
                      </div>
                      <div style={{ width: 150 }}>
                        <ColHelp helpKey="route">Route</ColHelp>
                      </div>
                      <div style={{ width: 150 }}>
                        <ColHelp helpKey="bomCharge">BOM Charge</ColHelp>
                      </div>
                      <div style={{ width: 100 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {variantValues?.presList
                      ?.filter((li) => !li?.delete)
                      ?.map((pr, ind) => {
                        const reqUnit = getRightPackageUom(
                          getBatch(
                            pr?.stockId,
                            pr?.batchNumber?.value ?? pr?.batchId,
                          )?.packageUom ??
                            getBatchList(pr?.stockId)?.[0]?.packageUom,
                          true,
                        );
                        const reqStck = pr?.stockId
                          ? getStockById(pr?.stockId)
                          : null;
                        const dosageField = (
                          <CustomTextField
                            fullWidth
                            handleChange={(e) =>
                              handleChangeAdminsterValue(
                                "dosage",
                                e?.target?.value,
                                ind,
                              )
                            }
                            value={pr?.dosage}
                            error={!!pr?.dosErr}
                            helperText={pr?.dosErr}
                            suffix={
                              reqUnit?.length > 0 ? (
                                <Custom3dotString
                                  str={`${reqUnit}`}
                                  length={7}
                                  className="fs12 font-medium"
                                  capitalize={false}
                                />
                              ) : (
                                ""
                              )
                            }
                          />
                        );

                        return (
                          <div
                            className="flex-row mt10 plan-bor"
                            key={ind + "pres"}
                          >
                            <div style={{ width: 250 }} className="pr10">
                              <Select
                                list={getList(true)}
                                value={pr?.name}
                                error={!!pr?.nameErr}
                                helperText={pr?.nameErr}
                                addNewSelect
                                searchOnly
                                mandatoryField
                                handleChange={(e) => {
                                  handleChangeAdminsterValue(
                                    "name",
                                    e?.value ?? e,
                                    ind,
                                    {
                                      stockId: e?.stockId ?? null,
                                      productId: e?.productId ?? null,
                                      serviceId: e?.serviceId ?? null,
                                      type: e?.type,
                                    },
                                  );
                                }}
                              />
                            </div>
                            {/* <div style={{ width: 220 }} className="pr10">
                              <CustomSelect
                                list={getBatches(pr?.stockId)}
                                value={pr?.batchNumber}
                                handleChange={(e, value) => {
                                  handleChangeAdminsterValue(
                                    "batchNumber",
                                    value,
                                    ind,
                                  );
                                }}
                                name="batchNumber"
                                search
                                isBatchNumber
                              />
                            </div> */}
                            <div style={{ width: 150 }} className="pr10">
                              <CustomTextField
                                value={pr?.quantity}
                                error={!!pr?.qtyErr}
                                helperText={pr?.qtyErr}
                                handleChange={(e) =>
                                  handleChangeAdminsterValue(
                                    "quantity",
                                    e?.target?.value,
                                    ind,
                                  )
                                }
                                fullWidth
                                type="number"
                              />
                            </div>
                            <div style={{ width: 170 }} className="pr10">
                              <CustomSelect
                                list={getUOMListByStockId(pr?.stockId)}
                                value={pr?.uom}
                                search
                                handleChange={(e, value) => {
                                  handleChangeAdminsterValue("uom", value, ind);
                                }}
                              />
                            </div>
                            <div style={{ width: 150 }} className="pr10">
                              {pr?.stockId ? (
                                <Tooltip
                                  title={
                                    <>
                                      <Typography
                                        className="fs12"
                                        display="block"
                                      >
                                        Approximated Dosage:{" "}
                                        {reqStck?.dosage ?? "-"}
                                      </Typography>
                                      <Typography
                                        className="fs12"
                                        display="block"
                                      >
                                        Dosage Type:{" "}
                                        {reqStck?.dosageType ?? "-"}
                                      </Typography>
                                    </>
                                  }
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "100%",
                                    }}
                                  >
                                    {dosageField}
                                  </span>
                                </Tooltip>
                              ) : (
                                dosageField
                              )}
                            </div>
                            <div style={{ width: 150 }} className="pr10">
                              <Select
                                list={routeList}
                                value={pr?.route}
                                error={!!pr?.routeErr}
                                helperText={pr?.routeErr}
                                search
                                handleChange={(e, value) => {
                                  handleChangeAdminsterValue(
                                    "route",
                                    value,
                                    ind,
                                  );
                                }}
                              />
                            </div>
                            <div style={{ width: 150 }} className="pr10 mt10">
                              <Typography className="txt-regular fs12 gray20 ml5">
                                {Number(pr?.cost) > 0
                                  ? `Rs ${Number(pr?.cost)?.toFixed(2)}`
                                  : "-"}
                              </Typography>
                            </div>
                            <div style={{ width: 100 }}>
                              <div className="flex-row-ali-cen">
                                <div
                                  className="cursor"
                                  onClick={() =>
                                    handleAdminAlternates(pr?.i, true)
                                  }
                                >
                                  <div className="flex-center">
                                    <AddIcon sx={plusBtn} />
                                  </div>
                                  <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                    Alternates
                                  </Typography>
                                </div>
                                <div
                                  className="cursor ml10"
                                  onClick={() =>
                                    deleteAdministerByIndex(
                                      ind,
                                      pr?.prescriptionId ?? null,
                                    )
                                  }
                                >
                                  <div className="flex-center">
                                    <DeleteOutlineIcon sx={delBtn} />
                                  </div>
                                  <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                    Delete
                                  </Typography>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => handleAddTask("pres")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="mt20">
            <Card sx={cardSty}>
              <div className="flex-row-ali-cen">
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Prescription
                  </Typography>
                  <FieldInfoIcon text={SERVICE_FIELD_HELP.prescription} />
                </div>
              </div>
              <div
                style={{ overflowX: "auto", width: "100%" }}
                className="mt10"
              >
                <div style={{ minWidth: 1270 }}>
                  <div className="flex-row-ali-cen mh10">
                    <div style={{ width: 250 }}>
                      <ColHelp helpKey="itemName">
                        Name <span className="red-color">*</span>
                      </ColHelp>
                    </div>
                    {/* <div style={{ width: 150 }}>
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Qty <span className="red-color">*</span>
                      </Typography>
                    </div> */}
                    <div style={{ width: 150 }}>
                      <ColHelp helpKey="dose">Dose</ColHelp>
                    </div>
                    <div style={{ width: 150 }}>
                      <ColHelp helpKey="frequency">Frequency</ColHelp>
                    </div>
                    <div style={{ width: 150 }}>
                      <ColHelp helpKey="route">Route</ColHelp>
                    </div>
                    <div style={{ width: 150 }}>
                      <ColHelp helpKey="duration">Duration</ColHelp>
                    </div>
                    <div style={{ width: 150 }}>
                      <ColHelp helpKey="instructions">Instructions</ColHelp>
                    </div>
                    <div style={{ width: 200 }}>
                      <ColHelp helpKey="remarks">Remarks</ColHelp>
                    </div>
                    <div style={{ width: 70 }} />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {variantValues?.prescriptions
                    ?.filter((li) => !li?.delete)
                    ?.map((pr, ind) => {
                      const reqUnit = getRightPackageUom(
                        getBatchList(pr?.stockId)?.[0]?.packageUom,
                        true,
                      );
                      const reqStck = pr?.stockId
                        ? getStockById(pr?.stockId)
                        : null;
                      const dosageField = (
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangePrescripValue(
                              "dosage",
                              e?.target?.value,
                              ind,
                            )
                          }
                          value={pr?.dosage}
                          error={!!pr?.dosErr}
                          helperText={pr?.dosErr}
                          suffix={
                            reqUnit?.length > 0 ? (
                              <Custom3dotString
                                str={`${reqUnit}`}
                                length={7}
                                className="fs12 font-medium"
                                capitalize={false}
                              />
                            ) : (
                              ""
                            )
                          }
                        />
                      );

                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={ind + "pres"}
                        >
                          <div className="pr10" style={{ width: 250 }}>
                            <Select
                              list={getPresList()}
                              value={pr?.name}
                              error={!!pr?.nameErr}
                              helperText={pr?.nameErr}
                              addNewSelect
                              searchOnly
                              mandatoryField
                              handleChange={(e) => {
                                handleChangePrescripValue(
                                  "name",
                                  e?.value ?? e,
                                  ind,
                                  {
                                    stockId: e?.stockId ?? null,
                                    productId: e?.productId ?? null,
                                    serviceId: e?.serviceId ?? null,
                                    type: e?.type,
                                  },
                                );
                              }}
                            />
                          </div>
                          {/* <div className="pr10" style={{ width: 150 }}>
                            <CustomTextField
                              value={pr?.qty}
                              error={!!pr?.qtyErr}
                              helperText={pr?.qtyErr}
                              handleChange={(e) => {
                                handleChangePrescripValue(
                                  "qty",
                                  e?.target?.value,
                                  pr?.i,
                                );
                              }}
                              fullWidth
                              type="number"
                              endIcon
                              inputIcon={
                                <Custom3dotString
                                  str={`${
                                    getBatchList(pr?.stockId)?.[0]?.salesUom ??
                                    ""
                                  }`}
                                  length={7}
                                  className="fs12 font-medium"
                                />
                              }
                            />
                          </div> */}
                          <div style={{ width: 150 }} className="pr10">
                            {pr?.stockId ? (
                              <Tooltip
                                title={
                                  <>
                                    <Typography
                                      className="fs12"
                                      display="block"
                                    >
                                      Approximated Dosage:{" "}
                                      {reqStck?.dosage ?? "-"}
                                    </Typography>
                                    <Typography
                                      className="fs12"
                                      display="block"
                                    >
                                      Dosage Type: {reqStck?.dosageType ?? "-"}
                                    </Typography>
                                  </>
                                }
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "100%",
                                  }}
                                >
                                  {dosageField}
                                </span>
                              </Tooltip>
                            ) : (
                              dosageField
                            )}
                          </div>
                          <div style={{ width: 150 }} className="pr10">
                            {pr?.customFrequency ? (
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangePrescripValue(
                                    "frequency",
                                    e?.target?.value,
                                    pr?.i,
                                  )
                                }
                                value={pr?.frequency}
                              />
                            ) : (
                              <CustomSelect
                                list={frequncyCheckList}
                                value={pr?.frequency ?? []}
                                handleChange={(e) => {
                                  handleChangePrescripValue(
                                    "frequency",
                                    e?.target?.value,
                                    pr?.i,
                                  );
                                }}
                                multiSelectTagCheck
                              />
                            )}
                          </div>
                          <div className="pr10" style={{ width: 150 }}>
                            <CustomSelect
                              list={routeList}
                              value={pr?.route}
                              search
                              handleChange={(e, value) => {
                                handleChangePrescripValue(
                                  "route",
                                  value,
                                  pr?.i,
                                );
                              }}
                            />
                          </div>
                          <div style={{ width: 150 }} className="pr10">
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handleChangePrescripValue(
                                  "duration",
                                  e?.target?.value,
                                  pr?.i,
                                )
                              }
                              value={pr?.duration}
                              endIcon
                              inputIcon="days"
                              type="number"
                            />
                          </div>
                          <div style={{ width: 150 }} className="pr10">
                            <CustomSelect
                              list={mealTypes}
                              value={pr?.meal}
                              select
                              handleChange={(e) => {
                                handleChangePrescripValue(
                                  "meal",
                                  e?.target?.value,
                                  pr?.i,
                                );
                              }}
                            />
                          </div>
                          <div style={{ width: 200 }} className="pr10">
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handleChangePrescripValue(
                                  "remark",
                                  e?.target?.value,
                                  pr?.i,
                                )
                              }
                              value={pr?.remark}
                            />
                          </div>
                          <div style={{ width: 70 }}>
                            <div
                              className="cursor ml10"
                              onClick={() =>
                                deletePricripByIndex(
                                  ind,
                                  pr?.prescriptionId ?? null,
                                )
                              }
                            >
                              <div className="flex-center">
                                <DeleteOutlineIcon sx={delBtn} />
                              </div>
                              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                Delete
                              </Typography>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleAddTask("prescriptions")}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                </div>
              </div>
            </Card>
          </div>
          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Save" smallBtn onClick={saveVariant} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={getOpenedConsum()}
        onClose={onCloseConsumMod}
        header="Consumables"
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <div className="flex-row-ali-cen">
            <div className="flex-row-ali-cen">
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs14 blue-color">
                  Consumables
                </Typography>
                <FieldInfoIcon text={SERVICE_FIELD_HELP.consumables} />
              </div>
            </div>
          </div>
          <div className="flex-column mt10">
            <div className="flex-row-ali-cen mh10">
              <div className="w10Per">
                <ColHelp helpKey="defaultItem">Default Item</ColHelp>
              </div>
              <div className="w30Per">
                <ColHelp helpKey="itemName">
                  Name <span className="red-color">*</span>
                </ColHelp>
              </div>
              {/* <div className="w20Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Batch Number
                </Typography>
              </div> */}
              <div className="w20Per">
                <ColHelp helpKey="billableQty">
                  Billable Qty <span className="red-color">*</span>
                </ColHelp>
              </div>
              <div className="w20Per">
                <ColHelp helpKey="uom">UOM</ColHelp>
              </div>
              <div className="w20Per">
                <ColHelp helpKey="bomCharge">BOM Charge</ColHelp>
              </div>
              <div className="w5Per" />
            </div>
            <div className="blue-hor-split mt5" />
            {alternates
              ?.filter((li) => !li?.delete)
              ?.map((li, i) => {
                return (
                  <div
                    className="flex-row mt10 plan-bor"
                    key={li?.i + "consum var"}
                  >
                    <div className="w10Per">
                      <div className="ml10">
                        <CustomCheckbox
                          checked={li?.isDefault}
                          onChange={() => onChangeConsumDefault(li?.i)}
                        />
                      </div>
                    </div>
                    <div className="w30Per pr10">
                      <CustomSelect
                        list={getModalList(false)}
                        value={li?.name}
                        addNewSelect
                        mandatoryField
                        error={!!li?.nameErr}
                        helperText={li?.nameErr}
                        handleChange={(e) => {
                          onChangeConsumValue("name", e?.value ?? e, li?.i, {
                            stockId: e?.stockId ?? null,
                            batchId: e?.batchId ?? null,
                            serviceId: e?.serviceId ?? null,
                            category: e?.category ?? null,
                          });
                        }}
                        plusBtn
                      />
                    </div>
                    {/* <div className="w20Per pr10">
                      <CustomSelect
                        list={getBatches(li?.stockId)}
                        value={li?.batchNumber}
                        handleChange={(e, value) => {
                          onChangeConsumValue("batchNumber", value, i);
                        }}
                        name="batchNumber"
                        search
                        isBatchNumber
                      />
                    </div> */}
                    <div className="w20Per pr10">
                      <CustomTextField
                        value={li?.quantity}
                        error={!!li?.qtyErr}
                        helperText={li?.qtyErr}
                        handleChange={(e) =>
                          onChangeConsumValue("quantity", e?.target?.value, i)
                        }
                        fullWidth
                        type="number"
                      />
                    </div>
                    <div className="w20Per pr10">
                      <CustomSelect
                        list={getUOMListByStockId(li?.stockId)}
                        value={li?.uom}
                        search
                        handleChange={(e, value) => {
                          onChangeConsumValue("uom", value, i);
                        }}
                      />
                    </div>
                    <div className="w20Per pr10 mt10">
                      <Typography className="txt-regular fs12 gray20 ml5">
                        {Number(li?.cost) > 0
                          ? `Rs ${Number(li?.cost)?.toFixed(2)}`
                          : "-"}
                      </Typography>
                    </div>
                    <div className="w5Per flex-end mt5">
                      {!li?.isDefault ? (
                        <div
                          className="cursor pr10"
                          onClick={() =>
                            onDeleteAlterConsum(li?.i, li?.detailId ?? null)
                          }
                        >
                          <div className="flex-center">
                            <DeleteOutlineIcon sx={delBtn} />
                          </div>
                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                            Delete
                          </Typography>
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            <div
              className="flex-row-ali-cen mt10 cursor"
              onClick={handleAddConsum}
            >
              <div className="flex-center plus-icon">
                <AddIcon sx={plusBtn} />
              </div>
              <Typography className="blue-color fs16 ml5 font-bold">
                Add
              </Typography>
            </div>
            <div className="flex1-end">
              <div>
                <CustomButton text="Save" smallBtn onClick={handleSaveConsum} />
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={getOpenedAdmin()}
        onClose={onCloseAdminMod}
        header="Administered"
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <div className="flex-row-ali-cen" onClick={handleAdminOpen}>
            <div className="flex-row-ali-cen">
              <Typography className="font-bold fs14 blue-color">
                Administered
              </Typography>
              <FieldInfoIcon text={SERVICE_FIELD_HELP.administered} />
            </div>
          </div>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <div style={{ minWidth: 1190 }}>
              <div className="flex-column mt10">
                <div className="flex-row-ali-cen mh10">
                  <div style={{ width: 120 }}>
                    <ColHelp helpKey="defaultItem">Default Item</ColHelp>
                  </div>
                  <div style={{ width: 250 }}>
                    <ColHelp helpKey="itemName">
                      Name <span className="red-color">*</span>
                    </ColHelp>
                  </div>
                  {/* <div style={{ width: 220 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Batch Number
                    </Typography>
                  </div> */}
                  <div style={{ width: 150 }}>
                    <ColHelp helpKey="billableQty">
                      Billable Qty <span className="red-color">*</span>
                    </ColHelp>
                  </div>
                  <div style={{ width: 170 }}>
                    <ColHelp helpKey="uom">UOM</ColHelp>
                  </div>
                  <div style={{ width: 150 }}>
                    <ColHelp helpKey="dose">Dose</ColHelp>
                  </div>
                  <div style={{ width: 150 }}>
                    <ColHelp helpKey="route">Route</ColHelp>
                  </div>
                  <div style={{ width: 150 }}>
                    <ColHelp helpKey="bomCharge">BOM Charge</ColHelp>
                  </div>
                  <div style={{ width: 50 }} />
                </div>
              </div>
              <div className="blue-hor-split mt5" />
              {alternates
                ?.filter((li) => !li?.delete)
                ?.map((pr, ind) => {
                  const reqUnit = getRightPackageUom(
                    getBatchList(pr?.stockId)?.[0]?.packageUom,
                    true,
                  );
                  const reqStck = pr?.stockId
                    ? getStockById(pr?.stockId)
                    : null;
                  const dosageField = (
                    <CustomTextField
                      fullWidth
                      handleChange={(e) =>
                        onChangeAdminValue("dosage", e?.target?.value, ind)
                      }
                      value={pr?.dosage}
                      error={!!pr?.dosErr}
                      helperText={pr?.dosErr}
                      suffix={
                        reqUnit?.length > 0 ? (
                          <Custom3dotString
                            str={`${reqUnit}`}
                            length={7}
                            className="fs12 font-medium"
                            capitalize={false}
                          />
                        ) : (
                          ""
                        )
                      }
                    />
                  );

                  return (
                    <div
                      className="flex-row mt10 plan-bor"
                      key={ind + "admin var"}
                    >
                      <div style={{ width: 120 }} className="pl10">
                        <CustomCheckbox
                          checked={pr?.isDefault}
                          onChange={() => onChangeAdminDefault(pr?.i)}
                        />
                      </div>
                      <div style={{ width: 250 }} className="pr10">
                        <Select
                          list={getModalList(true)}
                          value={pr?.name}
                          error={!!pr?.nameErr}
                          helperText={pr?.nameErr}
                          addNewSelect
                          mandatoryField
                          handleChange={(e) => {
                            onChangeAdminValue("name", e?.value ?? e, pr?.i, {
                              stockId: e?.stockId ?? null,
                              productId: e?.productId ?? null,
                              serviceId: e?.serviceId ?? null,
                              type: e?.type,
                            });
                          }}
                          plusBtn
                        />
                      </div>
                      {/* <div style={{ width: 220 }} className="pr10">
                        <CustomSelect
                          list={getBatches(pr?.stockId)}
                          value={pr?.batchNumber}
                          handleChange={(e, value) => {
                            onChangeAdminValue("batchNumber", value, ind);
                          }}
                          name="batchNumber"
                          search
                          isBatchNumber
                        />
                      </div> */}
                      <div style={{ width: 150 }} className="pr10">
                        <CustomTextField
                          value={pr?.quantity}
                          error={!!pr?.qtyErr}
                          helperText={pr?.qtyErr}
                          handleChange={(e) =>
                            onChangeAdminValue(
                              "quantity",
                              e?.target?.value,
                              ind,
                            )
                          }
                          fullWidth
                          type="number"
                        />
                      </div>
                      <div style={{ width: 170 }} className="pr10">
                        <CustomSelect
                          list={getUOMListByStockId(pr?.stockId)}
                          value={pr?.uom}
                          search
                          handleChange={(e, value) => {
                            onChangeAdminValue("uom", value, ind);
                          }}
                        />
                      </div>
                      <div style={{ width: 150 }} className="pr10">
                        {pr?.stockId ? (
                          <Tooltip
                            title={
                              <>
                                <Typography className="fs12" display="block">
                                  Approximated Dosage: {reqStck?.dosage ?? "-"}
                                </Typography>
                                <Typography className="fs12" display="block">
                                  Dosage Type: {reqStck?.dosageType ?? "-"}
                                </Typography>
                              </>
                            }
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "100%",
                              }}
                            >
                              {dosageField}
                            </span>
                          </Tooltip>
                        ) : (
                          dosageField
                        )}
                      </div>
                      <div style={{ width: 150 }} className="pr10">
                        <Select
                          list={routeList}
                          value={pr?.route}
                          error={!!pr?.routeErr}
                          helperText={pr?.routeErr}
                          search
                          handleChange={(e, value) => {
                            onChangeAdminValue("route", value, ind);
                          }}
                        />
                      </div>
                      <div style={{ width: 150 }} className="pr10 mt10">
                        <Typography className="txt-regular fs12 gray20 ml5">
                          {Number(pr?.cost) > 0
                            ? `Rs ${Number(pr?.cost)?.toFixed(2)}`
                            : "-"}
                        </Typography>
                      </div>
                      <div style={{ width: 50 }}>
                        {!pr?.isDefault ? (
                          <div
                            className="cursor ml10 mt5"
                            onClick={() =>
                              onDeleteAlterAdmin(
                                pr?.i,
                                pr?.prescriptionId ?? null,
                              )
                            }
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div
            className="flex-row-ali-cen mt10 cursor"
            onClick={handleAddAdmin}
          >
            <div className="flex-center plus-icon">
              <AddIcon sx={addIcon} />
            </div>
            <Typography className="blue-color fs16 ml5 font-bold">
              Add
            </Typography>
          </div>
          <div className="flex1-end">
            <div>
              <CustomButton text="Save" smallBtn onClick={handleSaveAdmin} />
            </div>
          </div>
        </div>
      </CustomModal>
      <ReminderTemplateModal
        open={remainderModalOpen}
        onClose={handleCloseRemainderModal}
        selectedTemp={selectedRemainder}
        onSave={handleSaveRemainder}
        isSaving={remainderSaving}
      />
      <CustomModal
        open={addRemainderOpen}
        onClose={() => {
          setAddRemainderOpen(false);
          setPickedRemainder("");
        }}
        header="Add Reminder Template"
        modal
        modalWidth={40}
      >
        <div className="ml10 mr10">
          <Typography className="fs12 gray-color mb10">
            Link an existing template to this service, or create a new one.
          </Typography>
          <CustomSelect
            list={unlinkedRemainderOptions}
            value={
              unlinkedRemainderOptions?.find(
                (opt) => String(opt?.value) === String(pickedRemainder),
              ) ?? null
            }
            search
            handleChange={(e, value) => setPickedRemainder(value?.value ?? "")}
            label="Existing template"
          />
          <div className="flex-row-ali-cen mt15 mb10 flex-center">
            <div>
              <CustomButton
                text="Create new"
                onClick={handleCreateRemainder}
                smallBtn
                disabled={remainderSaving}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="Link template"
                onClick={handleConfirmLinkRemainder}
                smallBtn
                disabled={!pickedRemainder || remainderSaving}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={addDiagTempOpen}
        onClose={() => {
          setAddDiagTempOpen(false);
          setPickedDiagTemp("");
        }}
        header="Add Diagnostic Template"
        modal
        modalWidth={40}
      >
        <div className="ml10 mr10">
          <Typography className="fs12 gray-color mb10">
            Link an existing template to this service, or create a new one.
          </Typography>
          <CustomSelect
            list={unlinkedDiagnosticOptions}
            value={
              unlinkedDiagnosticOptions?.find(
                (opt) => String(opt?.value) === String(pickedDiagTemp),
              ) ?? null
            }
            search
            handleChange={(e, value) => {
              const selected = value !== undefined ? value : e?.target?.value;
              setPickedDiagTemp(selected?.value ?? selected ?? "");
            }}
            label="Existing template"
          />
          <div className="flex-row-ali-cen mt15 mb10 flex-center">
            <div>
              <CustomButton
                text="Create new"
                onClick={handleCreateDiagnosticTemplate}
                smallBtn
                disabled={diagTempSaving}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="Link template"
                onClick={handleConfirmLinkDiagnosticTemplate}
                smallBtn
                disabled={!pickedDiagTemp || diagTempSaving}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      {diagTempCreateVsble ? (
        <CustomModal
          open={diagTempCreateVsble}
          onClose={handleCloseDiagnosticTemplateCreate}
          header="Diagnostic Template"
          modal
          modalWidth={90}
        >
          <DiagnosticTemplateCreate
            setCreateVsble={(vsble) => {
              if (!vsble) handleCloseDiagnosticTemplateCreate();
              else setDiagTempCreateVsble(true);
            }}
            selectedTemp={selectedDiagTemp}
            setSelectedTemp={setSelectedDiagTemp}
            onSave={handleSaveDiagnosticTemplate}
            forceLinkedServiceId={currentServiceId}
            forceLinkedServiceName={
              selectedService?.serviceName ?? serviceValues?.serviceName ?? ""
            }
          />
        </CustomModal>
      ) : null}
      <CustomModal
        open={addFormOpen}
        onClose={() => {
          setAddFormOpen(false);
          setPickedForm("");
        }}
        header="Add Consent Form"
        modal
        modalWidth={40}
      >
        <div className="ml10 mr10">
          <Typography className="fs12 gray-color mb10">
            Link an existing consent form to this service, or create a new one.
          </Typography>
          <CustomSelect
            list={unlinkedFormOptions}
            value={
              unlinkedFormOptions?.find(
                (opt) => String(opt?.value) === String(pickedForm),
              ) ?? null
            }
            search
            handleChange={(e, value) => setPickedForm(value?.value ?? "")}
            label="Existing form"
          />
          <div className="flex-row-ali-cen mt15 mb10 flex-center">
            <div>
              <CustomButton
                text="Create new"
                onClick={handleCreateForm}
                smallBtn
                disabled={formSaving}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="Link form"
                onClick={handleConfirmLinkForm}
                smallBtn
                disabled={!pickedForm || formSaving}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={formEditorOpen}
        onClose={handleCloseFormEditor}
        header={selectedForm ? "Edit Consent Form" : "Create Consent Form"}
        modal
        modalWidth={60}
      >
        <div className="ph20 pb20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <div className="txt-semi-bold fs14 blue-color mb5">Name</div>
              <CustomTextField
                fullWidth
                value={formEditorValues?.name}
                handleChange={(e) =>
                  setFormEditorValues((prev) => ({
                    ...prev,
                    name: e?.target?.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <div className="txt-semi-bold fs14 blue-color mb5">
                Service Type
              </div>
              <CustomSelect
                list={[
                  { name: "Admission", value: "Admission" },
                  ...serviceTypes,
                ]}
                value={formEditorValues?.serviceType}
                handleChange={(e) =>
                  setFormEditorValues((prev) => ({
                    ...prev,
                    serviceType: e?.target?.value,
                  }))
                }
                select
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 blue-color mb5">Content</div>
              <CustomTextField
                fullWidth
                multiline
                rows={8}
                value={formEditorValues?.content}
                handleChange={(e) =>
                  setFormEditorValues((prev) => ({
                    ...prev,
                    content: e?.target?.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <CustomButton
                  text="Save"
                  smallBtn
                  onClick={handleSaveFormEditor}
                  disabled={formSaving}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
      <CustomModal
        open={addCertOpen}
        onClose={() => {
          setAddCertOpen(false);
          setPickedCert("");
        }}
        header="Add Certificate"
        modal
        modalWidth={40}
      >
        <div className="ml10 mr10">
          <Typography className="fs12 gray-color mb10">
            Link an existing certificate to this service.
          </Typography>
          <CustomSelect
            list={unlinkedCertificateOptions}
            value={
              unlinkedCertificateOptions?.find(
                (opt) => String(opt?.value) === String(pickedCert),
              ) ?? null
            }
            search
            handleChange={(e, value) => setPickedCert(value?.value ?? "")}
            label="Existing certificate"
          />
          <div className="flex-row-ali-cen mt15 mb10 flex-center">
            <CustomButton
              text="Link certificate"
              onClick={handleConfirmLinkCertificate}
              smallBtn
              disabled={!pickedCert || certSaving}
            />
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={certEditorOpen}
        onClose={handleCloseCertificateEditor}
        header="Edit Certificate"
        modal
        modalWidth={50}
      >
        <div className="ph20 pb20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 blue-color mb5">Name</div>
              <CustomTextField
                fullWidth
                value={certEditorValues?.name}
                handleChange={(e) =>
                  setCertEditorValues((prev) => ({
                    ...prev,
                    name: e?.target?.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 blue-color mb5">Note</div>
              <CustomTextField
                fullWidth
                multiline
                rows={3}
                value={certEditorValues?.note}
                handleChange={(e) =>
                  setCertEditorValues((prev) => ({
                    ...prev,
                    note: e?.target?.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <CustomButton
                  text="Save"
                  smallBtn
                  onClick={handleSaveCertificateEditor}
                  disabled={certSaving}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default ServiceCreateUpdate;
